// // import React, { useState, useEffect, useRef } from 'react';
// // import axios from 'axios';
// // import { FaEdit, FaTrash } from 'react-icons/fa';
// // import { useLoader } from "../../../../context/LoaderProvider.jsx";
// // import * as XLSX from 'xlsx';

// // const ItemUpdates = () => {
// //     const [data, setData] = useState([]);
// //     const [loading, setLoading] = useState(true);
// //     const [error, setError] = useState(null);
// //     const [filteredData, setFilteredData] = useState([]);
// //     const [editItem, setEditItem] = useState(null);
// //     const [showEditModal, setShowEditModal] = useState(false);
// //     const { showLoader, hideLoader } = useLoader();
// //     const fileInputRef = useRef(null);
// //     const [showPopup, setShowPopup] = useState(false);



// //     const handleFileImport = async (e) => {
// //         const file = e.target.files[0];
// //         if (!file) return alert("Please choose a file.");

// //         const vendorId = localStorage.getItem("vendorId");
// //         const authToken = localStorage.getItem("authToken");

// //         if (!vendorId) return alert("Vendor ID not found in local storage.");
// //         if (!authToken) return alert("No auth token found. Please log in first.");

// //         const formData = new FormData();
// //         formData.append("file", file);

// //         try {
// //             const response = await axios.post(
// //                 `https://backend.maamaas.com/food/api/dish/import/${vendorId}`,
// //                 formData,
// //                 {
// //                     headers: {
// //                         "Content-Type": "multipart/form-data",
// //                         Authorization: `Bearer ${authToken}`,
// //                     },
// //                 }
// //             );

// //             //console.log("✅ Import successful:", response.data);
// //             alert("✅ Categories imported successfully!");
// //             setTimeout(() => window.location.reload(), 1000);

// //         } catch (error) {
// //             console.error("❌ Import failed:", error);
// //             if (error.response) {
// //                 alert(`❌ Import failed: ${error.response.status} - ${error.response.data?.message || "Server error"}`);
// //             } else {
// //                 alert("❌ Import failed: Network or unknown error.");
// //             }
// //         }
// //     };
// //     // Fetch data on component mount
// //     const fetchData = async () => {
// //         const vendorId = localStorage.getItem("vendorId");
// //         const token = localStorage.getItem("authToken");

// //         if (!vendorId) {
// //             console.warn("⚠️ vendorId not found in localStorage");
// //             setError(new Error("vendorId missing"));
// //             setLoading(false);
// //             return;
// //         }

// //         if (!token) {
// //             console.warn("⚠️ authToken not found in localStorage");
// //             setError(new Error("authToken missing"));
// //             setLoading(false);
// //             return;
// //         }

// //         try {
// //             showLoader();
// //             const response = await fetch(
// //                 `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
// //                 {
// //                     headers: {
// //                         "Content-Type": "application/json",
// //                         "Authorization": `Bearer ${token}`
// //                     }
// //                 }
// //             );

// //             if (!response.ok) {
// //                 throw new Error(`HTTP error! status: ${response.status}`);
// //             }

// //             const dishData = await response.json();

// //             // Get parent categories (categories)
// //             const parentCategories = dishData.filter(item => item.parentId === 0 || item.parentId === null);

// //             // Format the data with categories and their subcategories
// //             let formattedData = parentCategories.map(category => {
// //                 // Get subcategories for this category
// //                 const subcategories = dishData.filter(sub => sub.parentId === category.dishId);

// //                 return {
// //                     dishId: category.dishId,
// //                     SNo: category.dishId,
// //                     category: category.dishName,
// //                     quantity: category.stockQuantity || "-",
// //                     consumed: category.consumedQuantity || "-",
// //                     balance: category.balanceQuantity || "-",
// //                     itemStatus: category.menuStatus || "Enable",
// //                     isAdded: true,
// //                     subcategories: subcategories.map((sub, subIndex) => ({
// //                         dishId: sub.dishId,
// //                         subName: sub.subName || sub.dishName,
// //                         quantity: sub.stockQuantity || 0,
// //                         consumed: sub.consumedQuantity || 0,
// //                         balance: sub.balanceQuantity || 0,
// //                         itemStatus: sub.menuStatus || "Enable",
// //                         isSubcategory: true
// //                     }))
// //                 };
// //             });

// //             //console.log("Formatted Item Update Data with subcategories:", formattedData);

// //             // Ensure category status reflects on subcategories (in case of data inconsistency)
// //             formattedData = formattedData.map(category => {
// //                 // If category is disabled, disable all subcategories
// //                 if (category.itemStatus === "Disable") {
// //                     return {
// //                         ...category,
// //                         subcategories: category.subcategories.map(sub => ({
// //                             ...sub,
// //                             itemStatus: "Disable"
// //                         }))
// //                     };
// //                 }
// //                 return category;
// //             });

// //             setData(formattedData);
// //             setFilteredData(formattedData);

// //         } catch (error) {
// //             console.error("Error fetching data:", error);
// //             setError(error);
// //         } finally {
// //             setLoading(false);
// //             hideLoader();
// //         }
// //     };

// //     useEffect(() => {
// //         fetchData();
// //     }, []);

// //     // Handle edit quantity
// //     const handleEditQuantity = (item, isSubcategory = false, parentIndex = null) => {
// //         setEditItem({
// //             ...item,
// //             newQuantity: item.quantity,
// //             isSubcategory,
// //             parentIndex
// //         });
// //         setShowEditModal(true);
// //     };

// //     // Submit edited quantity
// //     const submitEditQuantity = async () => {
// //         if (!editItem || !editItem.dishId) {
// //             alert("Dish ID is missing!");
// //             return;
// //         }

// //         const token = localStorage.getItem("authToken");
// //         if (!token) {
// //             alert("Authentication token missing. Please log in again.");
// //             return;
// //         }

// //         try {
// //             showLoader();
// //             const url = `https://backend.maamaas.com/food/api/dish/edit/${editItem.dishId}`;

// //             const formData = new FormData();

// //             // JSON data as blob - only update stockQuantity
// //             const dishData = {
// //                 stockQuantity: editItem.newQuantity
// //                 // Other fields will remain unchanged
// //             };

// //             formData.append("dishData", new Blob([JSON.stringify(dishData)], { type: "application/json" }));

// //             const response = await axios.put(url, formData, {
// //                 headers: {
// //                     "Authorization": `Bearer ${token}`,
// //                     "Content-Type": "multipart/form-data",
// //                 },
// //             });

// //             //console.log('Quantity update successful:', response.data);
// //             alert('Quantity updated successfully!');

// //             // Update local state
// //             if (editItem.isSubcategory && editItem.parentIndex !== null) {
// //                 // Update subcategory quantity
// //                 setData(prevData => {
// //                     const updatedData = [...prevData];
// //                     const subIndex = updatedData[editItem.parentIndex].subcategories.findIndex(
// //                         sub => sub.dishId === editItem.dishId
// //                     );
// //                     if (subIndex !== -1) {
// //                         updatedData[editItem.parentIndex].subcategories[subIndex].quantity = editItem.newQuantity;
// //                     }
// //                     return updatedData;
// //                 });
// //                 setFilteredData(prevData => {
// //                     const updatedData = [...prevData];
// //                     const subIndex = updatedData[editItem.parentIndex].subcategories.findIndex(
// //                         sub => sub.dishId === editItem.dishId
// //                     );
// //                     if (subIndex !== -1) {
// //                         updatedData[editItem.parentIndex].subcategories[subIndex].quantity = editItem.newQuantity;
// //                     }
// //                     return updatedData;
// //                 });
// //             } else {
// //                 // Update category quantity
// //                 setData(prevData =>
// //                     prevData.map(item =>
// //                         item.dishId === editItem.dishId
// //                             ? { ...item, quantity: editItem.newQuantity }
// //                             : item
// //                     )
// //                 );
// //                 setFilteredData(prevData =>
// //                     prevData.map(item =>
// //                         item.dishId === editItem.dishId
// //                             ? { ...item, quantity: editItem.newQuantity }
// //                             : item
// //                     )
// //                 );
// //             }

// //             setShowEditModal(false);
// //             setEditItem(null);

// //         } catch (error) {
// //             console.error("Error updating quantity:", error);
// //             if (error.response) {
// //                 console.error("Response data:", error.response.data);
// //                 alert(`Failed to update quantity: ${error.response.data.message || error.response.data}`);
// //             } else {
// //                 alert(`Failed to update quantity: ${error.message}`);
// //             }
// //         } finally {
// //             hideLoader();
// //         }
// //     };

// //     // Handle toggle item status
// //     // Handle toggle item status
// //     const handleToggleStatus = async (index, dishId, currentStatus, isSubcategory = false, parentIndex = null) => {
// //         const vendorId = localStorage.getItem("vendorId");
// //         const authToken = localStorage.getItem("authToken");

// //         if (!vendorId || !authToken) {
// //             alert("Authentication failed. Please login again.");
// //             return;
// //         }
// //         // Prevent toggling subcategory if parent category is disabled
// //         if (isSubcategory && parentIndex !== null) {
// //             const parentCategory = data[parentIndex];
// //             if (parentCategory && parentCategory.itemStatus === "Disable") {
// //                 alert("Cannot toggle subcategory when parent category is hidden.");
// //                 return;
// //             }
// //         }

// //         const newBool = currentStatus !== "Enable";
// //         const newStatus = newBool ? "Enable" : "Disable";

// //         if (isSubcategory && parentIndex !== null) {
// //             // Update subcategory status
// //             setData(prevData => {
// //                 const updatedData = [...prevData];
// //                 const subIndex = updatedData[parentIndex].subcategories.findIndex(
// //                     sub => sub.dishId === dishId
// //                 );
// //                 if (subIndex !== -1) {
// //                     updatedData[parentIndex].subcategories[subIndex].itemStatus = newStatus;
// //                 }
// //                 return updatedData;
// //             });
// //             setFilteredData(prevData => {
// //                 const updatedData = [...prevData];
// //                 const subIndex = updatedData[parentIndex].subcategories.findIndex(
// //                     sub => sub.dishId === dishId
// //                 );
// //                 if (subIndex !== -1) {
// //                     updatedData[parentIndex].subcategories[subIndex].itemStatus = newStatus;
// //                 }
// //                 return updatedData;
// //             });
// //         } else {
// //             // Update category status - ALSO UPDATE ALL ITS SUBCATEGORIES
// //             setData(prevData => {
// //                 const updatedData = [...prevData];
// //                 updatedData[index] = {
// //                     ...updatedData[index],
// //                     itemStatus: newStatus,
// //                     // Also update all subcategories to same status
// //                     subcategories: updatedData[index].subcategories.map(sub => ({
// //                         ...sub,
// //                         itemStatus: newStatus
// //                     }))
// //                 };
// //                 return updatedData;
// //             });
// //             setFilteredData(prevData => {
// //                 const updatedData = [...prevData];
// //                 updatedData[index] = {
// //                     ...updatedData[index],
// //                     itemStatus: newStatus,
// //                     // Also update all subcategories to same status
// //                     subcategories: updatedData[index].subcategories.map(sub => ({
// //                         ...sub,
// //                         itemStatus: newStatus
// //                     }))
// //                 };
// //                 return updatedData;
// //             });
// //         }

// //         try {
// //             // For category, update all subcategories as well
// //             if (!isSubcategory) {
// //                 // First update the category
// //                 const categoryUrl = `https://backend.maamaas.com/food/api/dish/editmenu/${dishId}`;
// //                 const categoryPayload = { menuStatus: newStatus };

// //                 await axios.put(categoryUrl, categoryPayload, {
// //                     headers: {
// //                         'Content-Type': 'application/json',
// //                         'Authorization': `Bearer ${authToken}`,
// //                     },
// //                 });

// //                 // Then update all subcategories of this category
// //                 const category = data[index];
// //                 if (category.subcategories && category.subcategories.length > 0) {
// //                     for (const sub of category.subcategories) {
// //                         const subUrl = `https://backend.maamaas.com/food/api/dish/editmenu/${sub.dishId}`;
// //                         const subPayload = { menuStatus: newStatus };

// //                         await axios.put(subUrl, subPayload, {
// //                             headers: {
// //                                 'Content-Type': 'application/json',
// //                                 'Authorization': `Bearer ${authToken}`,
// //                             },
// //                         });

// //                         localStorage.setItem(`menuStatus-${sub.dishId}`, newStatus);
// //                     }
// //                 }
// //             } else {
// //                 // For subcategory, update only that subcategory
// //                 const url = `https://backend.maamaas.com/food/api/dish/editmenu/${dishId}`;
// //                 const payload = { menuStatus: newStatus };

// //                 await axios.put(url, payload, {
// //                     headers: {
// //                         'Content-Type': 'application/json',
// //                         'Authorization': `Bearer ${authToken}`,
// //                     },
// //                 });
// //             }

// //             localStorage.setItem(`menuStatus-${dishId}`, newStatus);

// //         } catch (error) {
// //             console.error('Failed to toggle menu visibility:', error);
// //             alert('Failed to update menu visibility.');

// //             // Rollback UI
// //             if (isSubcategory && parentIndex !== null) {
// //                 setData(prevData => {
// //                     const updatedData = [...prevData];
// //                     const subIndex = updatedData[parentIndex].subcategories.findIndex(
// //                         sub => sub.dishId === dishId
// //                     );
// //                     if (subIndex !== -1) {
// //                         updatedData[parentIndex].subcategories[subIndex].itemStatus = currentStatus;
// //                     }
// //                     return updatedData;
// //                 });
// //                 setFilteredData(prevData => {
// //                     const updatedData = [...prevData];
// //                     const subIndex = updatedData[parentIndex].subcategories.findIndex(
// //                         sub => sub.dishId === dishId
// //                     );
// //                     if (subIndex !== -1) {
// //                         updatedData[parentIndex].subcategories[subIndex].itemStatus = currentStatus;
// //                     }
// //                     return updatedData;
// //                 });
// //             } else {
// //                 setData(prevData => {
// //                     const updatedData = [...prevData];
// //                     updatedData[index].itemStatus = currentStatus;
// //                     // Also rollback subcategories
// //                     updatedData[index].subcategories = updatedData[index].subcategories.map(sub => ({
// //                         ...sub,
// //                         itemStatus: sub.itemStatus // Keep their original status or could store previous states
// //                     }));
// //                     return updatedData;
// //                 });
// //                 setFilteredData(prevData => {
// //                     const updatedData = [...prevData];
// //                     updatedData[index].itemStatus = currentStatus;
// //                     // Also rollback subcategories
// //                     updatedData[index].subcategories = updatedData[index].subcategories.map(sub => ({
// //                         ...sub,
// //                         itemStatus: sub.itemStatus
// //                     }));
// //                     return updatedData;
// //                 });
// //             }
// //         }
// //     };
// //     const handleExport = () => {
// //         if (!filteredData || filteredData.length === 0) {
// //             alert("No data available to export.");
// //             return;
// //         }

// //         const exportData = [];

// //         filteredData.forEach((category, index) => {
// //             exportData.push({
// //                 "S.No": index + 1,
// //                 "Category": category.category || "",
// //                 "Subcategory": "",
// //                 "Quantity": category.quantity || "",
// //                 "Consumed": category.consumed || "",
// //                 "Balance": category.balance || "",
// //             });

// //             if (category.subcategories && category.subcategories.length > 0) {
// //                 category.subcategories.forEach((sub) => {
// //                     exportData.push({
// //                         "S.No": "",
// //                         "Category": category.categoryName || "",
// //                         "Subcategory": sub.subName || "",
// //                         "Quantity": sub.quantity || "",
// //                         "Consumed": sub.consumed || "",
// //                         "Balance": sub.balance || "",
// //                     });
// //                 });
// //             }
// //         });

// //         const worksheet = XLSX.utils.json_to_sheet(exportData);
// //         const workbook = XLSX.utils.book_new();
// //         XLSX.utils.book_append_sheet(workbook, worksheet, "Menu Data");

// //         const colWidths = Object.keys(exportData[0]).map((key) => ({
// //             wch: Math.max(
// //                 key.length,
// //                 ...exportData.map((row) => String(row[key] || "").length)
// //             ),
// //         }));
// //         worksheet["!cols"] = colWidths;

// //         XLSX.writeFile(workbook, "menu_data_export.xlsx");
// //     };
// //     // Handle delete item
// //     const handleDeleteItem = async (dishId, isSubcategory = false, parentIndex = null) => {
// //         if (!window.confirm("Are you sure you want to delete this item?")) return;

// //         const token = localStorage.getItem("authToken");

// //         try {
// //             showLoader();
// //             const response = await fetch(
// //                 `https://backend.maamaas.com/food/api/dish/delete/${dishId}`,
// //                 {
// //                     method: "DELETE",
// //                     headers: {
// //                         "Authorization": `Bearer ${token}`,
// //                     },
// //                 }
// //             );

// //             if (response.ok) {
// //                 alert("Item deleted successfully!");

// //                 if (isSubcategory && parentIndex !== null) {
// //                     // Delete subcategory
// //                     setData(prevData => {
// //                         const updatedData = [...prevData];
// //                         updatedData[parentIndex].subcategories = updatedData[parentIndex].subcategories.filter(
// //                             sub => sub.dishId !== dishId
// //                         );
// //                         return updatedData;
// //                     });
// //                     setFilteredData(prevData => {
// //                         const updatedData = [...prevData];
// //                         updatedData[parentIndex].subcategories = updatedData[parentIndex].subcategories.filter(
// //                             sub => sub.dishId !== dishId
// //                         );
// //                         return updatedData;
// //                     });
// //                 } else {
// //                     // Delete category
// //                     const newData = data.filter(item => item.dishId !== dishId);
// //                     setData(newData);
// //                     setFilteredData(newData);
// //                 }
// //             } else {
// //                 const result = await response.json();
// //                 alert(`Failed to delete item. Error: ${result.message || "Unknown error"}`);
// //             }
// //         } catch (error) {
// //             alert("An error occurred while deleting.");
// //             console.error(error);
// //         } finally {
// //             hideLoader();
// //         }
// //     };

// //     // Get responsive units based on viewport
// //     const getResponsiveValue = (mobile, tablet, desktop) => {
// //         const width = window.innerWidth;
// //         if (width < 768) return mobile;
// //         if (width < 1024) return tablet;
// //         return desktop;
// //     };

// //     // Responsive container height using vh units
// //     const containerHeight = getResponsiveValue('48vh', '50vh', '50vh');

// //     // Responsive table styles using rem and % units
// //     const tableHeaderStyle = {
// //         border: '1px solid #ddd',
// //         textAlign: 'center',
// //         fontWeight: 'bold',
// //         backgroundColor: '#b15cd6',
// //         color: 'white',
// //         padding: getResponsiveValue('0.5rem', '0.75rem', '0.875rem'),
// //         fontSize: getResponsiveValue('0.75rem', '0.875rem', '1rem'),
// //         whiteSpace: 'nowrap',
// //     };

// //     const tableCellStyle = {
// //         border: '1px solid #ddd',
// //         textAlign: 'center',
// //         padding: getResponsiveValue('0.4rem', '0.6rem', '0.75rem'),
// //         fontSize: getResponsiveValue('0.75rem', '0.875rem', '1rem'),
// //         wordBreak: 'break-word',
// //     };

// //     const categoryRowStyle = {
// //         backgroundColor: '#f0f0f0',
// //         fontWeight: 'bold'
// //     };

// //     const subcategoryRowStyle = {
// //         backgroundColor: '#f9f9f9'
// //     };

// //     const editButtonStyle = {
// //         backgroundColor: '#fff',
// //         color: 'green',
// //         border: 'none',
// //         cursor: 'pointer',
// //         borderRadius: '0.25rem',
// //         marginRight: getResponsiveValue('0.25rem', '0.5rem', '0.625rem'),
// //         fontSize: getResponsiveValue('1rem', '1.125rem', '1.25rem'),
// //         padding: getResponsiveValue('0.25rem', '0.375rem', '0.5rem'),
// //         display: 'inline-flex',
// //         alignItems: 'center',
// //         justifyContent: 'center'
// //     };

// //     const deleteButtonStyle = {
// //         backgroundColor: '#fff',
// //         color: 'red',
// //         border: 'none',
// //         cursor: 'pointer',
// //         borderRadius: '0.25rem',
// //         fontSize: getResponsiveValue('1rem', '1.125rem', '1.25rem'),
// //         padding: getResponsiveValue('0.25rem', '0.375rem', '0.5rem'),
// //         display: 'inline-flex',
// //         alignItems: 'center',
// //         justifyContent: 'center'
// //     };

// //     const modalStyle = {
// //         position: 'fixed',
// //         top: '50%',
// //         left: '50%',
// //         transform: 'translate(-50%, -50%)',
// //         backgroundColor: 'white',
// //         padding: getResponsiveValue('1rem', '1.25rem', '1.5rem'),
// //         borderRadius: '0.625rem',
// //         boxShadow: '0 0.125rem 0.625rem rgba(0, 0, 0, 0.1)',
// //         zIndex: 1000,
// //         width: getResponsiveValue('85%', '75%', '50%'),
// //         maxWidth: '25rem',
// //     };

// //     const inputFieldStyle = {
// //         width: '100%',
// //         padding: getResponsiveValue('0.5rem', '0.625rem', '0.75rem'),
// //         fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem'),
// //         borderRadius: '0.375rem',
// //         border: '1px solid #ddd',
// //         marginBottom: '1rem',
// //         boxSizing: 'border-box',
// //     };

// //     const buttonContainerStyle = {
// //         display: 'flex',
// //         justifyContent: 'center',
// //         marginTop: '1.25rem',
// //         textAlign: "center"
// //     };

// //     const buttonStyle = {
// //         height: getResponsiveValue('2rem', '2.25rem', '2.5rem'),
// //         backgroundColor: '#b15cd6',
// //         color: 'white',
// //         border: 'none',
// //         borderRadius: '0.375rem',
// //         cursor: 'pointer',
// //         fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem'),
// //         fontWeight: "bold",
// //         marginTop: "0.625rem",
// //         padding: getResponsiveValue('0 1rem', '0 1.25rem', '0 1.5rem'),
// //         minWidth: '8rem',
// //     };

// //     const closeButtonStyle = {
// //         position: 'absolute',
// //         top: getResponsiveValue('0.5rem', '0.75rem', '1rem'),
// //         right: getResponsiveValue('0.5rem', '0.75rem', '1rem'),
// //         cursor: 'pointer',
// //         fontSize: getResponsiveValue('1.25rem', '1.5rem', '1.75rem'),
// //         fontWeight: 'bold',
// //         color: '#888',
// //         lineHeight: '1',
// //         padding: '0.25rem',
// //     };

// //     return (
// //         <div style={{
// //             marginTop:  window.innerWidth<768 ? "0rem" : "2rem",
// //             padding: getResponsiveValue('0.5rem', '1rem', '1.25rem'),
// //             width: '100%',
// //             boxSizing: 'border-box',
// //             marginLeft: "-1rem",
// //         }}>
// //             {/* <h2 style={{ 
// //                 marginBottom: "1rem", 
// //                 color: "#333",
// //                 fontSize: getResponsiveValue('1.125rem', '1.5rem', '1.75rem'),
// //                 textAlign: 'start',
// //                 fontWeight: '600'
// //             }}>
// //                 Items Update
// //             </h2> */}
// //             <div className='importexportaddbutton' style={{ display: "flex", gap: "10px", marginBottom:window.innerWidth<768 ? "0.5rem" : "1rem", marginTop: "-70px", padding: "10px,20px", justifyContent: "start" }}>
// //                 <input
// //                     type="file"
// //                     accept=".xlsx, .xls"
// //                     ref={fileInputRef}
// //                     onChange={handleFileImport}
// //                     style={{ display: 'none' }}
// //                 />

// //                 <button
// //                     style={importExportButton}
// //                     onClick={() => fileInputRef.current.click()}
// //                 >
// //                     Import
// //                 </button>

// //                 <button style={importExportButton} onClick={handleExport}>Export</button>
// //                 {/* <button style={importExportButton}
// //                     onClick={() => setShowPopup(true)}
// //                 >
// //                     Add Category
// //                 </button> */}
// //             </div>

// //             <div style={{
// //                 overflowX: "auto",
// //                 overflowY: "auto",
// //                 height: containerHeight,
// //                 border: '0px solid #ddd',
// //                 borderRadius: '0.375rem',
// //                 backgroundColor: '#fff',
// //                 width: '100%',
// //                 maxWidth: '100%',
// //                 boxSizing: 'border-box',
// //                 scrollbarWidth:"thin",
// //             }}
// //                 className="item-updates-table-data" >

// //                 {loading ? (
// //                     <div style={{
// //                         textAlign: 'center',
// //                         padding: '1.25rem',
// //                         display: 'flex',
// //                         alignItems: 'center',
// //                         justifyContent: 'center',
// //                         height: '100%'
// //                     }}>
// //                         <p style={{ fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem') }}>
// //                             Loading data...
// //                         </p>
// //                     </div>
// //                 ) : error ? (
// //                     <div style={{
// //                         textAlign: 'center',
// //                         padding: '1.25rem',
// //                         color: 'red',
// //                         display: 'flex',
// //                         alignItems: 'center',
// //                         justifyContent: 'center',
// //                         height: '100%'
// //                     }}>
// //                         <p style={{ fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem') }}>
// //                             Error fetching data: {error.message}
// //                         </p>
// //                     </div>
// //                 ) : filteredData.length === 0 ? (
// //                     <div style={{
// //                         textAlign: 'center',
// //                         padding: '1.25rem',
// //                         display: 'flex',
// //                         alignItems: 'center',
// //                         justifyContent: 'center',
// //                         height: '100%'
// //                     }}>
// //                         <p style={{ fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem') }}>
// //                             No items found
// //                         </p>
// //                     </div>
// //                 ) : (
// //                     <table style={{
// //                         width: '100%',
// //                         borderCollapse: 'collapse',
// //                         tableLayout: 'auto',
// //                         marginTop: "0",
// //                         minWidth: getResponsiveValue('100%', '100%', '100%'),
// //                     }}>
// //                         <thead>
// //                             <tr>
// //                                 <th style={{ ...tableHeaderStyle, width: '8%' }}>SNo</th>
// //                                 <th style={{ ...tableHeaderStyle, width: '25%' }}>category</th>
// //                                 <th style={{ ...tableHeaderStyle, width: '12%' }}>Quantity</th>
// //                                 <th style={{ ...tableHeaderStyle, width: '12%' }}>Consumed</th>
// //                                 <th style={{ ...tableHeaderStyle, width: '12%' }}>Balance</th>
// //                                 <th style={{ ...tableHeaderStyle, width: '15%' }}>Status</th>
// //                                 <th style={{ ...tableHeaderStyle, width: '16%' }}>Actions</th>
// //                             </tr>
// //                         </thead>
// //                         <tbody>
// //                             {filteredData.map((item, index) => (
// //                                 <React.Fragment key={item.dishId}>
// //                                     {/* Parent Category Row */}
// //                                     <tr style={categoryRowStyle}>
// //                                         <td style={tableCellStyle}>{index + 1}</td>
// //                                         <td style={tableCellStyle}>
// //                                             <strong style={{ fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem') }}>
// //                                                 {item.category}
// //                                             </strong>
// //                                         </td>
// //                                         <td style={tableCellStyle}>{item.quantity}</td>
// //                                         <td style={tableCellStyle}>{item.consumed}</td>
// //                                         <td style={tableCellStyle}>{item.balance}</td>
// //                                         <td style={tableCellStyle}>
// //                                             <div style={{
// //                                                 display: 'flex',
// //                                                 flexDirection: 'column',
// //                                                 alignItems: 'center',
// //                                                 justifyContent: 'center',
// //                                                 height: '100%'
// //                                             }}>
// //                                                 <label className="switch">
// //                                                     <input
// //                                                         type="checkbox"
// //                                                         checked={item.itemStatus === "Disable"}
// //                                                         onChange={() => handleToggleStatus(index, item.dishId, item.itemStatus, false)}
// //                                                     />
// //                                                     <span className="slider round"></span>
// //                                                 </label>
// //                                                 <span
// //                                                     style={{
// //                                                         marginTop: '0.25rem',
// //                                                         color: 'black',
// //                                                         fontSize: getResponsiveValue('0.75rem', '0.875rem', '1rem'),
// //                                                         cursor: 'pointer',
// //                                                     }}
// //                                                 >
// //                                                     {item.itemStatus === "Disable" ? 'Hide' : 'Show'}
// //                                                 </span>
// //                                             </div>
// //                                         </td>
// //                                         <td style={tableCellStyle}>
// //                                             <div style={{
// //                                                 display: 'flex',
// //                                                 justifyContent: 'center',
// //                                                 alignItems: 'center',
// //                                                 gap: getResponsiveValue('0.25rem', '0.5rem', '0.75rem')
// //                                             }}>
// //                                                 <button
// //                                                     style={editButtonStyle}
// //                                                     onClick={() => handleEditQuantity(item, false)}
// //                                                     title="Edit Quantity"
// //                                                     aria-label="Edit Quantity"
// //                                                 >
// //                                                     <FaEdit />
// //                                                 </button>
// //                                                 {/* <button
// //                                                     style={deleteButtonStyle}
// //                                                     onClick={() => handleDeleteItem(item.dishId, false)}
// //                                                     title="Delete"
// //                                                     aria-label="Delete"
// //                                                 >
// //                                                     <FaTrash />
// //                                                 </button> */}
// //                                             </div>
// //                                         </td>
// //                                     </tr>

// //                                     {/* Subcategories */}
// //                                     {item.subcategories && item.subcategories.map((sub, subIndex) => (
// //                                         <tr key={`sub-${sub.dishId}`} style={subcategoryRowStyle}>
// //                                             <td style={tableCellStyle}>
// //                                                 {index + 1}.{subIndex + 1}
// //                                             </td>
// //                                             <td style={tableCellStyle}>
// //                                                 <span style={{
// //                                                     marginLeft: getResponsiveValue('1rem', '1.5rem', '2rem'),
// //                                                     display: 'block',
// //                                                     textAlign: 'left',
// //                                                     fontSize: getResponsiveValue('0.75rem', '0.875rem', '1rem')
// //                                                 }}>
// //                                                     ↳ {sub.subName}
// //                                                 </span>
// //                                             </td>
// //                                             <td style={tableCellStyle}>{sub.quantity}</td>
// //                                             <td style={tableCellStyle}>{sub.consumed}</td>
// //                                             <td style={tableCellStyle}>{sub.balance}</td>
// //                                             <td style={tableCellStyle}>
// //                                                 <div style={{
// //                                                     display: 'flex',
// //                                                     flexDirection: 'column',
// //                                                     alignItems: 'center',
// //                                                     justifyContent: 'center',
// //                                                     height: '100%'
// //                                                 }}>
// //                                                     <label className="switch">
// //                                                         <input
// //                                                             type="checkbox"
// //                                                             checked={sub.itemStatus === "Disable"}
// //                                                             onChange={() => handleToggleStatus(subIndex, sub.dishId, sub.itemStatus, true, index)}
// //                                                             disabled={item.itemStatus === "Disable"} // 👈 DISABLE WHEN PARENT IS HIDDEN
// //                                                         />
// //                                                         <span className={`slider round ${item.itemStatus === "Disable" ? 'disabled' : ''}`}></span>
// //                                                     </label>
// //                                                     <span
// //                                                         style={{
// //                                                             marginTop: '0.25rem',
// //                                                             color: item.itemStatus === "Disable" ? '#999' : 'black', // Gray out text
// //                                                             fontSize: getResponsiveValue('0.75rem', '0.875rem', '1rem'),
// //                                                             cursor: item.itemStatus === "Disable" ? 'not-allowed' : 'pointer',
// //                                                         }}
// //                                                     >
// //                                                         {sub.itemStatus === "Disable" ? 'Hide' : 'Show'}
// //                                                     </span>
// //                                                 </div>
// //                                             </td>
// //                                             <td style={tableCellStyle}>
// //                                                 <div style={{
// //                                                     display: 'flex',
// //                                                     justifyContent: 'center',
// //                                                     alignItems: 'center',
// //                                                     gap: getResponsiveValue('0.25rem', '0.5rem', '0.75rem')
// //                                                 }}>
// //                                                     <button
// //                                                         style={{
// //                                                             ...editButtonStyle,
// //                                                             opacity: item.itemStatus === "Disable" ? 0.5 : 1, // 👈 Gray out when disabled
// //                                                             cursor: item.itemStatus === "Disable" ? 'not-allowed' : 'pointer'
// //                                                         }}
// //                                                         onClick={() => item.itemStatus !== "Disable" && handleEditQuantity(sub, true, index)} // 👈 Only clickable when parent not disabled
// //                                                         title="Edit Quantity"
// //                                                         aria-label="Edit Quantity"
// //                                                         disabled={item.itemStatus === "Disable"} // 👈 Disable button
// //                                                     >
// //                                                         <FaEdit />
// //                                                     </button>
// //                                                     {/* <button
// //                                                         style={{
// //                                                             ...deleteButtonStyle,
// //                                                             opacity: item.itemStatus === "Disable" ? 0.5 : 1,
// //                                                             cursor: item.itemStatus === "Disable" ? 'not-allowed' : 'pointer'
// //                                                         }}
// //                                                         onClick={() => item.itemStatus !== "Disable" && handleDeleteItem(sub.dishId, true, index)}
// //                                                         title="Delete"
// //                                                         aria-label="Delete"
// //                                                         disabled={item.itemStatus === "Disable"}
// //                                                     >
// //                                                         <FaTrash />
// //                                                     </button> */}
// //                                                 </div>
// //                                             </td>
// //                                         </tr>
// //                                     ))}
// //                                 </React.Fragment>
// //                             ))}
// //                         </tbody>
// //                     </table>
// //                 )}
// //             </div>

// //             {/* Edit Quantity Modal */}
// //             {/* Edit Quantity Modal - Horizontal layout */}
// //             {showEditModal && editItem && (
// //                 <div style={{
// //                     position: 'fixed',
// //                     top: 0,
// //                     left: 0,
// //                     right: 0,
// //                     bottom: 0,
// //                     backgroundColor: 'rgba(0,0,0,0.5)',
// //                     display: 'flex',
// //                     justifyContent: 'center',
// //                     alignItems: 'center',
// //                     zIndex: 1000,
// //                 }}>
// //                     <div style={{
// //                         backgroundColor: 'white',
// //                         padding: '1.5rem',
// //                         borderRadius: '8px',
// //                         width: '380px',
// //                         boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
// //                         position: 'relative',
// //                     }}>
// //                         {/* Close button - top right */}
// //                         <button
// //                             onClick={() => setShowEditModal(false)}
// //                             style={{
// //                                 position: 'absolute',
// //                                 top: '0px',
// //                                 right: '0px',
// //                                 background: 'none',
// //                                 border: 'none',
// //                                 fontSize: '1.5rem',
// //                                 cursor: 'pointer',
// //                                 color: '#999',
// //                                 padding: '0',
// //                                 lineHeight: '1',
// //                                 width: '24px',
// //                                 height: '24px',
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 justifyContent: 'center',
// //                                 borderRadius: '50%',
// //                                 transition: 'all 0.2s',
// //                             }}
// //                             onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
// //                             onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
// //                         >
// //                             ×
// //                         </button>

// //                         {/* Horizontal layout */}
// //                         <div style={{
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             gap: '1rem',
// //                         }}>
// //                             {/* Item name */}
// //                             <div style={{
// //                                 flex: '1',
// //                                 fontSize: '0.95rem',
// //                                 fontWeight: '600',
// //                                 color: '#333',
// //                                 overflow: 'hidden',
// //                                 textOverflow: 'ellipsis',
// //                                 whiteSpace: 'nowrap',
// //                                 minWidth: '80px',
// //                             }}>
// //                                 {editItem.isSubcategory ? editItem.subName : editItem.category}
// //                             </div>

// //                             {/* Quantity input */}
// //                             <div style={{ flex: '1' }}>
// //                                 <input
// //                                     type="number"
// //                                     value={editItem.newQuantity}
// //                                     onChange={(e) => setEditItem({ ...editItem, newQuantity: e.target.value })}
// //                                     style={{
// //                                         width: '90%',
// //                                         padding: '0.65rem 0.75rem',
// //                                         border: '1px solid #ddd',
// //                                         borderRadius: '6px',
// //                                         fontSize: '0.9rem',
// //                                         boxSizing: 'border-box',
// //                                         transition: 'border 0.2s',
// //                                     }}
// //                                     min="0"
// //                                     placeholder="Qty"
// //                                     autoFocus
// //                                     onFocus={(e) => e.target.style.borderColor = '#b15cd6'}
// //                                     onBlur={(e) => e.target.style.borderColor = '#ddd'}
// //                                 />
// //                             </div>

// //                             {/* Save button */}
// //                             <button
// //                                 onClick={submitEditQuantity}
// //                                 style={{
// //                                     backgroundColor: '#b15cd6',
// //                                     color: 'white',
// //                                     border: 'none',
// //                                     padding: '0.65rem 1.25rem',
// //                                     borderRadius: '6px',
// //                                     fontSize: '0.9rem',
// //                                     cursor: 'pointer',
// //                                     fontWeight: '600',
// //                                     whiteSpace: 'nowrap',
// //                                     transition: 'all 0.2s',
// //                                     minWidth: '80px',
// //                                 }}
// //                                 onMouseEnter={(e) => e.target.style.backgroundColor = '#9a4bc1'}
// //                                 onMouseLeave={(e) => e.target.style.backgroundColor = '#b15cd6'}
// //                             >
// //                                 Save
// //                             </button>
// //                         </div>
// //                     </div>
// //                 </div>
// //             )}
// //             <style>
// //                 {`
// //                 .switch .slider.disabled {
// //     background-color: #ccc;
// //     cursor: not-allowed;
// // }

// // .switch .slider.disabled::before {
// //     background-color: #888;
// // }
// //                 `}
// //             </style>
// //         </div>
// //     );
// // };

// // const importExportButton = {
// //     height: '35px',
// //     marginTop: "20px",
// //     borderRadius: "4px",
// //     border: "none",
// //     backgroundColor: "#b15cd6",
// //     color: "white",
// //     fontWeight: 'bold',
// // };

// // export default ItemUpdates;






// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import { FaEdit, FaTrash } from 'react-icons/fa';
// import { useLoader } from "../../../../context/LoaderProvider.jsx";
// import * as XLSX from 'xlsx';

// const ItemUpdates = () => {
//     const [data, setData] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [filteredData, setFilteredData] = useState([]);
//     const [editItem, setEditItem] = useState(null);
//     const [showEditModal, setShowEditModal] = useState(false);
//     const { showLoader, hideLoader } = useLoader();
//     const fileInputRef = useRef(null);
//     const [showPopup, setShowPopup] = useState(false);



//     const handleFileImport = async (e) => {
//         const file = e.target.files[0];
//         if (!file) return alert("Please choose a file.");

//         const vendorId = localStorage.getItem("vendorId");
//         const authToken = localStorage.getItem("authToken");

//         if (!vendorId) return alert("Vendor ID not found in local storage.");
//         if (!authToken) return alert("No auth token found. Please log in first.");

//         const formData = new FormData();
//         formData.append("file", file);

//         try {
//             const response = await axios.post(
//                 `https://backend.maamaas.com/food/api/dish/import/${vendorId}`,
//                 formData,
//                 {
//                     headers: {
//                         "Content-Type": "multipart/form-data",
//                         Authorization: `Bearer ${authToken}`,
//                     },
//                 }
//             );

//             //console.log("✅ Import successful:", response.data);
//             alert("✅ Categories imported successfully!");
//             setTimeout(() => window.location.reload(), 1000);

//         } catch (error) {
//             console.error("❌ Import failed:", error);
//             if (error.response) {
//                 alert(`❌ Import failed: ${error.response.status} - ${error.response.data?.message || "Server error"}`);
//             } else {
//                 alert("❌ Import failed: Network or unknown error.");
//             }
//         }
//     };
//     // Fetch data on component mount
//     const fetchData = async () => {
//         const vendorId = localStorage.getItem("vendorId");
//         const token = localStorage.getItem("authToken");

//         if (!vendorId) {
//             console.warn("⚠️ vendorId not found in localStorage");
//             setError(new Error("vendorId missing"));
//             setLoading(false);
//             return;
//         }

//         if (!token) {
//             console.warn("⚠️ authToken not found in localStorage");
//             setError(new Error("authToken missing"));
//             setLoading(false);
//             return;
//         }

//         try {
//             showLoader();
//             const response = await fetch(
//                 `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
//                 {
//                     headers: {
//                         "Content-Type": "application/json",
//                         "Authorization": `Bearer ${token}`
//                     }
//                 }
//             );

//             if (!response.ok) {
//                 throw new Error(`HTTP error! status: ${response.status}`);
//             }

//             const dishData = await response.json();

//             // Get parent categories (categories)
//             const parentCategories = dishData.filter(item => item.parentId === 0 || item.parentId === null);

//             // Format the data with categories and their subcategories
//             let formattedData = parentCategories.map(category => {
//                 // Get subcategories for this category
//                 const subcategories = dishData.filter(sub => sub.parentId === category.dishId);

//                 return {
//                     dishId: category.dishId,
//                     SNo: category.dishId,
//                     category: category.dishName,
//                     quantity: category.stockQuantity || "-",
//                     consumed: category.consumedQuantity || "-",
//                     balance: category.balanceQuantity || "-",
//                     itemStatus: category.menuStatus || "Enable",
//                     isAdded: true,
//                     subcategories: subcategories.map((sub, subIndex) => ({
//                         dishId: sub.dishId,
//                         subName: sub.subName || sub.dishName,
//                         quantity: sub.stockQuantity || 0,
//                         consumed: sub.consumedQuantity || 0,
//                         balance: sub.balanceQuantity || 0,
//                         itemStatus: sub.menuStatus || "Enable",
//                         isSubcategory: true
//                     }))
//                 };
//             });

//             //console.log("Formatted Item Update Data with subcategories:", formattedData);

//             // Ensure category status reflects on subcategories (in case of data inconsistency)
//             formattedData = formattedData.map(category => {
//                 // If category is disabled, disable all subcategories
//                 if (category.itemStatus === "Disable") {
//                     return {
//                         ...category,
//                         subcategories: category.subcategories.map(sub => ({
//                             ...sub,
//                             itemStatus: "Disable"
//                         }))
//                     };
//                 }
//                 return category;
//             });

//             setData(formattedData);
//             setFilteredData(formattedData);

//         } catch (error) {
//             console.error("Error fetching data:", error);
//             setError(error);
//         } finally {
//             setLoading(false);
//             hideLoader();
//         }
//     };

//     useEffect(() => {
//         fetchData();
//     }, []);

//     // Handle edit quantity
//     const handleEditQuantity = (item, isSubcategory = false, parentIndex = null) => {
//         setEditItem({
//             ...item,
//             newQuantity: item.quantity,
//             isSubcategory,
//             parentIndex
//         });
//         setShowEditModal(true);
//     };

//     // Submit edited quantity
//     const submitEditQuantity = async () => {
//         if (!editItem || !editItem.dishId) {
//             alert("Dish ID is missing!");
//             return;
//         }

//         const token = localStorage.getItem("authToken");
//         if (!token) {
//             alert("Authentication token missing. Please log in again.");
//             return;
//         }

//         try {
//             showLoader();
//             const url = `https://backend.maamaas.com/food/api/dish/edit/${editItem.dishId}`;

//             const formData = new FormData();

//             // JSON data as blob - only update stockQuantity
//             const dishData = {
//                 stockQuantity: editItem.newQuantity
//                 // Other fields will remain unchanged
//             };

//             formData.append("dishData", new Blob([JSON.stringify(dishData)], { type: "application/json" }));

//             const response = await axios.put(url, formData, {
//                 headers: {
//                     "Authorization": `Bearer ${token}`,
//                     "Content-Type": "multipart/form-data",
//                 },
//             });

//             //console.log('Quantity update successful:', response.data);
//             alert('Quantity updated successfully!');

//             // Update local state
//             if (editItem.isSubcategory && editItem.parentIndex !== null) {
//                 // Update subcategory quantity
//                 setData(prevData => {
//                     const updatedData = [...prevData];
//                     const subIndex = updatedData[editItem.parentIndex].subcategories.findIndex(
//                         sub => sub.dishId === editItem.dishId
//                     );
//                     if (subIndex !== -1) {
//                         updatedData[editItem.parentIndex].subcategories[subIndex].quantity = editItem.newQuantity;
//                     }
//                     return updatedData;
//                 });
//                 setFilteredData(prevData => {
//                     const updatedData = [...prevData];
//                     const subIndex = updatedData[editItem.parentIndex].subcategories.findIndex(
//                         sub => sub.dishId === editItem.dishId
//                     );
//                     if (subIndex !== -1) {
//                         updatedData[editItem.parentIndex].subcategories[subIndex].quantity = editItem.newQuantity;
//                     }
//                     return updatedData;
//                 });
//             } else {
//                 // Update category quantity
//                 setData(prevData =>
//                     prevData.map(item =>
//                         item.dishId === editItem.dishId
//                             ? { ...item, quantity: editItem.newQuantity }
//                             : item
//                     )
//                 );
//                 setFilteredData(prevData =>
//                     prevData.map(item =>
//                         item.dishId === editItem.dishId
//                             ? { ...item, quantity: editItem.newQuantity }
//                             : item
//                     )
//                 );
//             }

//             setShowEditModal(false);
//             setEditItem(null);

//         } catch (error) {
//             console.error("Error updating quantity:", error);
//             if (error.response) {
//                 console.error("Response data:", error.response.data);
//                 alert(`Failed to update quantity: ${error.response.data.message || error.response.data}`);
//             } else {
//                 alert(`Failed to update quantity: ${error.message}`);
//             }
//         } finally {
//             hideLoader();
//         }
//     };

//     // Handle toggle item status
//     // Handle toggle item status
//     const handleToggleStatus = async (index, dishId, currentStatus, isSubcategory = false, parentIndex = null) => {
//         const vendorId = localStorage.getItem("vendorId");
//         const authToken = localStorage.getItem("authToken");

//         if (!vendorId || !authToken) {
//             alert("Authentication failed. Please login again.");
//             return;
//         }
//         // Prevent toggling subcategory if parent category is disabled
//         if (isSubcategory && parentIndex !== null) {
//             const parentCategory = data[parentIndex];
//             if (parentCategory && parentCategory.itemStatus === "Disable") {
//                 alert("Cannot toggle subcategory when parent category is hidden.");
//                 return;
//             }
//         }

//         const newBool = currentStatus !== "Enable";
//         const newStatus = newBool ? "Enable" : "Disable";

//         if (isSubcategory && parentIndex !== null) {
//             // Update subcategory status
//             setData(prevData => {
//                 const updatedData = [...prevData];
//                 const subIndex = updatedData[parentIndex].subcategories.findIndex(
//                     sub => sub.dishId === dishId
//                 );
//                 if (subIndex !== -1) {
//                     updatedData[parentIndex].subcategories[subIndex].itemStatus = newStatus;
//                 }
//                 return updatedData;
//             });
//             setFilteredData(prevData => {
//                 const updatedData = [...prevData];
//                 const subIndex = updatedData[parentIndex].subcategories.findIndex(
//                     sub => sub.dishId === dishId
//                 );
//                 if (subIndex !== -1) {
//                     updatedData[parentIndex].subcategories[subIndex].itemStatus = newStatus;
//                 }
//                 return updatedData;
//             });
//         } else {
//             // Update category status - ALSO UPDATE ALL ITS SUBCATEGORIES
//             setData(prevData => {
//                 const updatedData = [...prevData];
//                 updatedData[index] = {
//                     ...updatedData[index],
//                     itemStatus: newStatus,
//                     // Also update all subcategories to same status
//                     subcategories: updatedData[index].subcategories.map(sub => ({
//                         ...sub,
//                         itemStatus: newStatus
//                     }))
//                 };
//                 return updatedData;
//             });
//             setFilteredData(prevData => {
//                 const updatedData = [...prevData];
//                 updatedData[index] = {
//                     ...updatedData[index],
//                     itemStatus: newStatus,
//                     // Also update all subcategories to same status
//                     subcategories: updatedData[index].subcategories.map(sub => ({
//                         ...sub,
//                         itemStatus: newStatus
//                     }))
//                 };
//                 return updatedData;
//             });
//         }

//         try {
//             // For category, update all subcategories as well
//             if (!isSubcategory) {
//                 // First update the category
//                 const categoryUrl = `https://backend.maamaas.com/food/api/dish/editmenu/${dishId}`;
//                 const categoryPayload = { menuStatus: newStatus };

//                 await axios.put(categoryUrl, categoryPayload, {
//                     headers: {
//                         'Content-Type': 'application/json',
//                         'Authorization': `Bearer ${authToken}`,
//                     },
//                 });

//                 // Then update all subcategories of this category
//                 const category = data[index];
//                 if (category.subcategories && category.subcategories.length > 0) {
//                     for (const sub of category.subcategories) {
//                         const subUrl = `https://backend.maamaas.com/food/api/dish/editmenu/${sub.dishId}`;
//                         const subPayload = { menuStatus: newStatus };

//                         await axios.put(subUrl, subPayload, {
//                             headers: {
//                                 'Content-Type': 'application/json',
//                                 'Authorization': `Bearer ${authToken}`,
//                             },
//                         });

//                         localStorage.setItem(`menuStatus-${sub.dishId}`, newStatus);
//                     }
//                 }
//             } else {
//                 // For subcategory, update only that subcategory
//                 const url = `https://backend.maamaas.com/food/api/dish/editmenu/${dishId}`;
//                 const payload = { menuStatus: newStatus };

//                 await axios.put(url, payload, {
//                     headers: {
//                         'Content-Type': 'application/json',
//                         'Authorization': `Bearer ${authToken}`,
//                     },
//                 });
//             }

//             localStorage.setItem(`menuStatus-${dishId}`, newStatus);

//         } catch (error) {
//             console.error('Failed to toggle menu visibility:', error);
//             alert('Failed to update menu visibility.');

//             // Rollback UI
//             if (isSubcategory && parentIndex !== null) {
//                 setData(prevData => {
//                     const updatedData = [...prevData];
//                     const subIndex = updatedData[parentIndex].subcategories.findIndex(
//                         sub => sub.dishId === dishId
//                     );
//                     if (subIndex !== -1) {
//                         updatedData[parentIndex].subcategories[subIndex].itemStatus = currentStatus;
//                     }
//                     return updatedData;
//                 });
//                 setFilteredData(prevData => {
//                     const updatedData = [...prevData];
//                     const subIndex = updatedData[parentIndex].subcategories.findIndex(
//                         sub => sub.dishId === dishId
//                     );
//                     if (subIndex !== -1) {
//                         updatedData[parentIndex].subcategories[subIndex].itemStatus = currentStatus;
//                     }
//                     return updatedData;
//                 });
//             } else {
//                 setData(prevData => {
//                     const updatedData = [...prevData];
//                     updatedData[index].itemStatus = currentStatus;
//                     // Also rollback subcategories
//                     updatedData[index].subcategories = updatedData[index].subcategories.map(sub => ({
//                         ...sub,
//                         itemStatus: sub.itemStatus // Keep their original status or could store previous states
//                     }));
//                     return updatedData;
//                 });
//                 setFilteredData(prevData => {
//                     const updatedData = [...prevData];
//                     updatedData[index].itemStatus = currentStatus;
//                     // Also rollback subcategories
//                     updatedData[index].subcategories = updatedData[index].subcategories.map(sub => ({
//                         ...sub,
//                         itemStatus: sub.itemStatus
//                     }));
//                     return updatedData;
//                 });
//             }
//         }
//     };
//     const handleExport = () => {
//         if (!filteredData || filteredData.length === 0) {
//             alert("No data available to export.");
//             return;
//         }

//         const exportData = [];

//         filteredData.forEach((category, index) => {
//             exportData.push({
//                 "S.No": index + 1,
//                 "Category": category.category || "",
//                 "Subcategory": "",
//                 "Quantity": category.quantity || "",
//                 "Consumed": category.consumed || "",
//                 "Balance": category.balance || "",
//             });

//             if (category.subcategories && category.subcategories.length > 0) {
//                 category.subcategories.forEach((sub) => {
//                     exportData.push({
//                         "S.No": "",
//                         "Category": category.categoryName || "",
//                         "Subcategory": sub.subName || "",
//                         "Quantity": sub.quantity || "",
//                         "Consumed": sub.consumed || "",
//                         "Balance": sub.balance || "",
//                     });
//                 });
//             }
//         });

//         const worksheet = XLSX.utils.json_to_sheet(exportData);
//         const workbook = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(workbook, worksheet, "Menu Data");

//         const colWidths = Object.keys(exportData[0]).map((key) => ({
//             wch: Math.max(
//                 key.length,
//                 ...exportData.map((row) => String(row[key] || "").length)
//             ),
//         }));
//         worksheet["!cols"] = colWidths;

//         XLSX.writeFile(workbook, "menu_data_export.xlsx");
//     };
//     // Handle delete item
//     const handleDeleteItem = async (dishId, isSubcategory = false, parentIndex = null) => {
//         if (!window.confirm("Are you sure you want to delete this item?")) return;

//         const token = localStorage.getItem("authToken");

//         try {
//             showLoader();
//             const response = await fetch(
//                 `https://backend.maamaas.com/food/api/dish/delete/${dishId}`,
//                 {
//                     method: "DELETE",
//                     headers: {
//                         "Authorization": `Bearer ${token}`,
//                     },
//                 }
//             );

//             if (response.ok) {
//                 alert("Item deleted successfully!");

//                 if (isSubcategory && parentIndex !== null) {
//                     // Delete subcategory
//                     setData(prevData => {
//                         const updatedData = [...prevData];
//                         updatedData[parentIndex].subcategories = updatedData[parentIndex].subcategories.filter(
//                             sub => sub.dishId !== dishId
//                         );
//                         return updatedData;
//                     });
//                     setFilteredData(prevData => {
//                         const updatedData = [...prevData];
//                         updatedData[parentIndex].subcategories = updatedData[parentIndex].subcategories.filter(
//                             sub => sub.dishId !== dishId
//                         );
//                         return updatedData;
//                     });
//                 } else {
//                     // Delete category
//                     const newData = data.filter(item => item.dishId !== dishId);
//                     setData(newData);
//                     setFilteredData(newData);
//                 }
//             } else {
//                 const result = await response.json();
//                 alert(`Failed to delete item. Error: ${result.message || "Unknown error"}`);
//             }
//         } catch (error) {
//             alert("An error occurred while deleting.");
//             console.error(error);
//         } finally {
//             hideLoader();
//         }
//     };

//     // Get responsive units based on viewport
//     const getResponsiveValue = (mobile, tablet, desktop) => {
//         const width = window.innerWidth;
//         if (width < 768) return mobile;
//         if (width < 1024) return tablet;
//         return desktop;
//     };

//     // Responsive container height using vh units
//     const containerHeight = getResponsiveValue('48vh', '50vh', '50vh');

//     // Responsive table styles using rem and % units
//     const tableHeaderStyle = {
//         border: '1px solid #ddd',
//         textAlign: 'center',
//         fontWeight: 'bold',
//         backgroundColor: '#b15cd6',
//         color: 'white',
//         padding: getResponsiveValue('0.5rem', '0.75rem', '0.875rem'),
//         fontSize: getResponsiveValue('0.75rem', '0.875rem', '1rem'),
//         whiteSpace: 'nowrap',
//     };

//     const tableCellStyle = {
//         border: '1px solid #ddd',
//         textAlign: 'center',
//         padding: getResponsiveValue('0.4rem', '0.6rem', '0.75rem'),
//         fontSize: getResponsiveValue('0.75rem', '0.875rem', '1rem'),
//         wordBreak: 'break-word',
//     };

//     const categoryRowStyle = {
//         backgroundColor: '#f0f0f0',
//         fontWeight: 'bold'
//     };

//     const subcategoryRowStyle = {
//         backgroundColor: '#f9f9f9'
//     };

//     const editButtonStyle = {
//         backgroundColor: '#fff',
//         color: 'green',
//         border: 'none',
//         cursor: 'pointer',
//         borderRadius: '0.25rem',
//         marginRight: getResponsiveValue('0.25rem', '0.5rem', '0.625rem'),
//         fontSize: getResponsiveValue('1rem', '1.125rem', '1.25rem'),
//         padding: getResponsiveValue('0.25rem', '0.375rem', '0.5rem'),
//         display: 'inline-flex',
//         alignItems: 'center',
//         justifyContent: 'center'
//     };

//     const deleteButtonStyle = {
//         backgroundColor: '#fff',
//         color: 'red',
//         border: 'none',
//         cursor: 'pointer',
//         borderRadius: '0.25rem',
//         fontSize: getResponsiveValue('1rem', '1.125rem', '1.25rem'),
//         padding: getResponsiveValue('0.25rem', '0.375rem', '0.5rem'),
//         display: 'inline-flex',
//         alignItems: 'center',
//         justifyContent: 'center'
//     };

//     const modalStyle = {
//         position: 'fixed',
//         top: '50%',
//         left: '50%',
//         transform: 'translate(-50%, -50%)',
//         backgroundColor: 'white',
//         padding: getResponsiveValue('1rem', '1.25rem', '1.5rem'),
//         borderRadius: '0.625rem',
//         boxShadow: '0 0.125rem 0.625rem rgba(0, 0, 0, 0.1)',
//         zIndex: 1000,
//         width: getResponsiveValue('85%', '75%', '50%'),
//         maxWidth: '25rem',
//     };

//     const inputFieldStyle = {
//         width: '100%',
//         padding: getResponsiveValue('0.5rem', '0.625rem', '0.75rem'),
//         fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem'),
//         borderRadius: '0.375rem',
//         border: '1px solid #ddd',
//         marginBottom: '1rem',
//         boxSizing: 'border-box',
//     };

//     const buttonContainerStyle = {
//         display: 'flex',
//         justifyContent: 'center',
//         marginTop: '1.25rem',
//         textAlign: "center"
//     };

//     const buttonStyle = {
//         height: getResponsiveValue('2rem', '2.25rem', '2.5rem'),
//         backgroundColor: '#b15cd6',
//         color: 'white',
//         border: 'none',
//         borderRadius: '0.375rem',
//         cursor: 'pointer',
//         fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem'),
//         fontWeight: "bold",
//         marginTop: "0.625rem",
//         padding: getResponsiveValue('0 1rem', '0 1.25rem', '0 1.5rem'),
//         minWidth: '8rem',
//     };

//     const closeButtonStyle = {
//         position: 'absolute',
//         top: getResponsiveValue('0.5rem', '0.75rem', '1rem'),
//         right: getResponsiveValue('0.5rem', '0.75rem', '1rem'),
//         cursor: 'pointer',
//         fontSize: getResponsiveValue('1.25rem', '1.5rem', '1.75rem'),
//         fontWeight: 'bold',
//         color: '#888',
//         lineHeight: '1',
//         padding: '0.25rem',
//     };

//     return (
//         <div style={{
//             marginTop:  window.innerWidth<768 ? "0rem" : "2rem",
//             padding: getResponsiveValue('0.5rem', '1rem', '1.25rem'),
//             width: window.innerWidth<500 ? '98vw': '100%',
//             boxSizing: 'border-box',
//             marginLeft: window.innerWidth<500 ? '-8px': "-1rem",
//         }}>
//             {/* <h2 style={{ 
//                 marginBottom: "1rem", 
//                 color: "#333",
//                 fontSize: getResponsiveValue('1.125rem', '1.5rem', '1.75rem'),
//                 textAlign: 'start',
//                 fontWeight: '600'
//             }}>
//                 Items Update
//             </h2> */}
//             <div className='importexportaddbutton' style={{ display: "flex", gap: "10px", marginBottom:window.innerWidth<768 ? "0.5rem" : "1rem", marginTop: "-70px", padding: "10px,20px", justifyContent: "start" }}>
//                 <input
//                     type="file"
//                     accept=".xlsx, .xls"
//                     ref={fileInputRef}
//                     onChange={handleFileImport}
//                     style={{ display: 'none' }}
//                 />

//                 <button
//                     style={importExportButton}
//                     onClick={() => fileInputRef.current.click()}
//                 >
//                     Import
//                 </button>

//                 <button style={importExportButton} onClick={handleExport}>Export</button>
//                 {/* <button style={importExportButton}
//                     onClick={() => setShowPopup(true)}
//                 >
//                     Add Category
//                 </button> */}
//             </div>

//             <div style={{
//                 overflowX: "auto",
//                 overflowY: "auto",
//                 height: containerHeight,
//                 border: '0px solid #ddd',
//                 borderRadius: '0.375rem',
//                 backgroundColor: '#fff',
//                 width: '100%',
//                 maxWidth: '100%',
//                 boxSizing: 'border-box',
//                 scrollbarWidth:"thin",
//             }}
//                 className="item-updates-table-data" >

//                 {loading ? (
//                     <div style={{
//                         textAlign: 'center',
//                         padding: '1.25rem',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         height: '100%'
//                     }}>
//                         <p style={{ fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem') }}>
//                             Loading data...
//                         </p>
//                     </div>
//                 ) : error ? (
//                     <div style={{
//                         textAlign: 'center',
//                         padding: '1.25rem',
//                         color: 'red',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         height: '100%'
//                     }}>
//                         <p style={{ fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem') }}>
//                             Error fetching data: {error.message}
//                         </p>
//                     </div>
//                 ) : filteredData.length === 0 ? (
//                     <div style={{
//                         textAlign: 'center',
//                         padding: '1.25rem',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         height: '100%'
//                     }}>
//                         <p style={{ fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem') }}>
//                             No items found
//                         </p>
//                     </div>
//                 ) : (
//                     <table style={{
//                         width: '100%',
//                         borderCollapse: 'collapse',
//                         tableLayout: 'auto',
//                         marginTop: "0",
//                         minWidth: getResponsiveValue('100%', '100%', '100%'),
//                     }}>
//                         <thead>
//                             <tr>
//                                 <th style={{ ...tableHeaderStyle, width: '8%' }}>SNo</th>
//                                 <th style={{ ...tableHeaderStyle, width: '25%' }}>category</th>
//                                 <th style={{ ...tableHeaderStyle, width: '12%' }}>Quantity</th>
//                                 <th style={{ ...tableHeaderStyle, width: '12%' }}>Consumed</th>
//                                 <th style={{ ...tableHeaderStyle, width: '12%' }}>Balance</th>
//                                 <th style={{ ...tableHeaderStyle, width: '15%' }}>Status</th>
//                                 <th style={{ ...tableHeaderStyle, width: '16%' }}>Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {filteredData.map((item, index) => (
//                                 <React.Fragment key={item.dishId}>
//                                     {/* Parent Category Row */}
//                                     <tr style={categoryRowStyle}>
//                                         <td style={tableCellStyle}>{index + 1}</td>
//                                         <td style={tableCellStyle}>
//                                             <strong style={{ fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem') }}>
//                                                 {item.category}
//                                             </strong>
//                                         </td>
//                                         <td style={tableCellStyle}>{item.quantity}</td>
//                                         <td style={tableCellStyle}>{item.consumed}</td>
//                                         <td style={tableCellStyle}>{item.balance}</td>
//                                         <td style={tableCellStyle}>
//                                             <div style={{
//                                                 display: 'flex',
//                                                 flexDirection: 'column',
//                                                 alignItems: 'center',
//                                                 justifyContent: 'center',
//                                                 height: '100%'
//                                             }}>
//                                                 <label className="switch">
//                                                     <input
//                                                         type="checkbox"
//                                                         checked={item.itemStatus === "Disable"}
//                                                         onChange={() => handleToggleStatus(index, item.dishId, item.itemStatus, false)}
//                                                     />
//                                                     <span className="slider round"></span>
//                                                 </label>
//                                                 <span
//                                                     style={{
//                                                         marginTop: '0.25rem',
//                                                         color: 'black',
//                                                         fontSize: getResponsiveValue('0.75rem', '0.875rem', '1rem'),
//                                                         cursor: 'pointer',
//                                                     }}
//                                                 >
//                                                     {item.itemStatus === "Disable" ? 'Hide' : 'Show'}
//                                                 </span>
//                                             </div>
//                                         </td>
//                                         <td style={tableCellStyle}>
//                                             <div style={{
//                                                 display: 'flex',
//                                                 justifyContent: 'center',
//                                                 alignItems: 'center',
//                                                 gap: getResponsiveValue('0.25rem', '0.5rem', '0.75rem')
//                                             }}>
//                                                 <button
//                                                     style={editButtonStyle}
//                                                     onClick={() => handleEditQuantity(item, false)}
//                                                     title="Edit Quantity"
//                                                     aria-label="Edit Quantity"
//                                                 >
//                                                     <FaEdit />
//                                                 </button>
//                                                 {/* <button
//                                                     style={deleteButtonStyle}
//                                                     onClick={() => handleDeleteItem(item.dishId, false)}
//                                                     title="Delete"
//                                                     aria-label="Delete"
//                                                 >
//                                                     <FaTrash />
//                                                 </button> */}
//                                             </div>
//                                         </td>
//                                     </tr>

//                                     {/* Subcategories */}
//                                     {item.subcategories && item.subcategories.map((sub, subIndex) => (
//                                         <tr key={`sub-${sub.dishId}`} style={subcategoryRowStyle}>
//                                             <td style={tableCellStyle}>
//                                                 {index + 1}.{subIndex + 1}
//                                             </td>
//                                             <td style={tableCellStyle}>
//                                                 <span style={{
//                                                     marginLeft: getResponsiveValue('1rem', '1.5rem', '2rem'),
//                                                     display: 'block',
//                                                     textAlign: 'left',
//                                                     fontSize: getResponsiveValue('0.75rem', '0.875rem', '1rem')
//                                                 }}>
//                                                     ↳ {sub.subName}
//                                                 </span>
//                                             </td>
//                                             <td style={tableCellStyle}>{sub.quantity}</td>
//                                             <td style={tableCellStyle}>{sub.consumed}</td>
//                                             <td style={tableCellStyle}>{sub.balance}</td>
//                                             <td style={tableCellStyle}>
//                                                 <div style={{
//                                                     display: 'flex',
//                                                     flexDirection: 'column',
//                                                     alignItems: 'center',
//                                                     justifyContent: 'center',
//                                                     height: '100%'
//                                                 }}>
//                                                     <label className="switch">
//                                                         <input
//                                                             type="checkbox"
//                                                             checked={sub.itemStatus === "Disable"}
//                                                             onChange={() => handleToggleStatus(subIndex, sub.dishId, sub.itemStatus, true, index)}
//                                                             disabled={item.itemStatus === "Disable"} // 👈 DISABLE WHEN PARENT IS HIDDEN
//                                                         />
//                                                         <span className={`slider round ${item.itemStatus === "Disable" ? 'disabled' : ''}`}></span>
//                                                     </label>
//                                                     <span
//                                                         style={{
//                                                             marginTop: '0.25rem',
//                                                             color: item.itemStatus === "Disable" ? '#999' : 'black', // Gray out text
//                                                             fontSize: getResponsiveValue('0.75rem', '0.875rem', '1rem'),
//                                                             cursor: item.itemStatus === "Disable" ? 'not-allowed' : 'pointer',
//                                                         }}
//                                                     >
//                                                         {sub.itemStatus === "Disable" ? 'Hide' : 'Show'}
//                                                     </span>
//                                                 </div>
//                                             </td>
//                                             <td style={tableCellStyle}>
//                                                 <div style={{
//                                                     display: 'flex',
//                                                     justifyContent: 'center',
//                                                     alignItems: 'center',
//                                                     gap: getResponsiveValue('0.25rem', '0.5rem', '0.75rem')
//                                                 }}>
//                                                     <button
//                                                         style={{
//                                                             ...editButtonStyle,
//                                                             opacity: item.itemStatus === "Disable" ? 0.5 : 1, // 👈 Gray out when disabled
//                                                             cursor: item.itemStatus === "Disable" ? 'not-allowed' : 'pointer'
//                                                         }}
//                                                         onClick={() => item.itemStatus !== "Disable" && handleEditQuantity(sub, true, index)} // 👈 Only clickable when parent not disabled
//                                                         title="Edit Quantity"
//                                                         aria-label="Edit Quantity"
//                                                         disabled={item.itemStatus === "Disable"} // 👈 Disable button
//                                                     >
//                                                         <FaEdit />
//                                                     </button>
//                                                     {/* <button
//                                                         style={{
//                                                             ...deleteButtonStyle,
//                                                             opacity: item.itemStatus === "Disable" ? 0.5 : 1,
//                                                             cursor: item.itemStatus === "Disable" ? 'not-allowed' : 'pointer'
//                                                         }}
//                                                         onClick={() => item.itemStatus !== "Disable" && handleDeleteItem(sub.dishId, true, index)}
//                                                         title="Delete"
//                                                         aria-label="Delete"
//                                                         disabled={item.itemStatus === "Disable"}
//                                                     >
//                                                         <FaTrash />
//                                                     </button> */}
//                                                 </div>
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </React.Fragment>
//                             ))}
//                         </tbody>
//                     </table>
//                 )}
//             </div>

//             {/* Edit Quantity Modal */}
//             {/* Edit Quantity Modal - Horizontal layout */}
//             {showEditModal && editItem && (
//                 <div style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     bottom: 0,
//                     backgroundColor: 'rgba(0,0,0,0.5)',
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     zIndex: 1000,
//                 }}>
//                     <div style={{
//                         backgroundColor: 'white',
//                         padding: '1.5rem',
//                         borderRadius: '8px',
//                         width: '380px',
//                         boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
//                         position: 'relative',
//                     }}>
//                         {/* Close button - top right */}
//                         <button
//                             onClick={() => setShowEditModal(false)}
//                             style={{
//                                 position: 'absolute',
//                                 top: '0px',
//                                 right: '0px',
//                                 background: 'none',
//                                 border: 'none',
//                                 fontSize: '1.5rem',
//                                 cursor: 'pointer',
//                                 color: '#999',
//                                 padding: '0',
//                                 lineHeight: '1',
//                                 width: '24px',
//                                 height: '24px',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 borderRadius: '50%',
//                                 transition: 'all 0.2s',
//                             }}
//                             onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
//                             onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
//                         >
//                             ×
//                         </button>

//                         {/* Horizontal layout */}
//                         <div style={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: '1rem',
//                         }}>
//                             {/* Item name */}
//                             <div style={{
//                                 flex: '1',
//                                 fontSize: '0.95rem',
//                                 fontWeight: '600',
//                                 color: '#333',
//                                 overflow: 'hidden',
//                                 textOverflow: 'ellipsis',
//                                 whiteSpace: 'nowrap',
//                                 minWidth: '80px',
//                             }}>
//                                 {editItem.isSubcategory ? editItem.subName : editItem.category}
//                             </div>

//                             {/* Quantity input */}
//                             <div style={{ flex: '1' }}>
//                                 <input
//                                     type="number"
//                                     value={editItem.newQuantity}
//                                     onChange={(e) => setEditItem({ ...editItem, newQuantity: e.target.value })}
//                                     style={{
//                                         width: '90%',
//                                         padding: '0.65rem 0.75rem',
//                                         border: '1px solid #ddd',
//                                         borderRadius: '6px',
//                                         fontSize: '0.9rem',
//                                         boxSizing: 'border-box',
//                                         transition: 'border 0.2s',
//                                     }}
//                                     min="0"
//                                     placeholder="Qty"
//                                     autoFocus
//                                     onFocus={(e) => e.target.style.borderColor = '#b15cd6'}
//                                     onBlur={(e) => e.target.style.borderColor = '#ddd'}
//                                 />
//                             </div>

//                             {/* Save button */}
//                             <button
//                                 onClick={submitEditQuantity}
//                                 style={{
//                                     backgroundColor: '#b15cd6',
//                                     color: 'white',
//                                     border: 'none',
//                                     padding: '0.65rem 1.25rem',
//                                     borderRadius: '6px',
//                                     fontSize: '0.9rem',
//                                     cursor: 'pointer',
//                                     fontWeight: '600',
//                                     whiteSpace: 'nowrap',
//                                     transition: 'all 0.2s',
//                                     minWidth: '80px',
//                                 }}
//                                 onMouseEnter={(e) => e.target.style.backgroundColor = '#9a4bc1'}
//                                 onMouseLeave={(e) => e.target.style.backgroundColor = '#b15cd6'}
//                             >
//                                 Save
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//             <style>
//                 {`
//                 .switch .slider.disabled {
//     background-color: #ccc;
//     cursor: not-allowed;
// }

// .switch .slider.disabled::before {
//     background-color: #888;
// }
//                 `}
//             </style>
//         </div>
//     );
// };

// const importExportButton = {
//     height: '35px',
//     marginTop: "20px",
//     borderRadius: "4px",
//     border: "none",
//     backgroundColor: "#b15cd6",
//     color: "white",
//     fontWeight: 'bold',
//     fontSize:"0.75rem",
// };

// export default ItemUpdates;




import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { useLoader } from "../../../../context/LoaderProvider.jsx";
import * as XLSX from 'xlsx';

const ItemUpdates = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [editItem, setEditItem] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const { showLoader, hideLoader } = useLoader();
    const fileInputRef = useRef(null);
    const [showPopup, setShowPopup] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchActive, setSearchActive] = useState(false);
    const [isVegSelected, setIsVegSelected] = useState(null);

    const normalizeForSearch = (text) => {
        if (!text) return '';

        // Convert to lowercase and replace multiple separators with space
        return text
            .toLowerCase()
            .replace(/[-\s_]+/g, ' ')  // Replace hyphens, underscores, multiple spaces with single space
            .trim();
    };

    const handleSearch = (query) => {
        const searchTerm = normalizeForSearch(query);
        setSearchQuery(query);

        if (!searchTerm) {
            setSearchActive(false);
            applyFilter(data, isVegSelected);
            return;
        }

        setSearchActive(true);

        // Create search patterns:
        // 1. Exact match (with spaces normalized)
        // 2. Without spaces (for "vegmeals")
        // 3. Individual words
        const searchWithoutSpaces = searchTerm.replace(/\s+/g, '');
        const searchWords = searchTerm.split(/\s+/).filter(w => w.length > 0);

        const searchResults = data.map(category => {
            // Normalize category
            const normalizedCategory = normalizeForSearch(category.category);
            const categoryWithoutSpaces = normalizedCategory.replace(/\s+/g, '');

            // Check category matches
            const categoryMatches =
                normalizedCategory.includes(searchTerm) ||
                categoryWithoutSpaces.includes(searchWithoutSpaces) ||
                searchWords.every(word => normalizedCategory.includes(word));

            // Filter subcategories
            const filteredSubcategories = category.subcategories?.filter(sub => {
                // Normalize subcategory fields
                const normalizedSubName = normalizeForSearch(sub.subName);
                const normalizedDescription = normalizeForSearch(sub.description);
                const normalizedTag = normalizeForSearch(sub.tag);

                const subNameWithoutSpaces = normalizedSubName.replace(/\s+/g, '');
                const descWithoutSpaces = normalizedDescription.replace(/\s+/g, '');

                // Multiple matching strategies
                const nameMatches =
                    normalizedSubName.includes(searchTerm) ||
                    subNameWithoutSpaces.includes(searchWithoutSpaces) ||
                    searchWords.every(word => normalizedSubName.includes(word));

                const descMatches =
                    normalizedDescription.includes(searchTerm) ||
                    descWithoutSpaces.includes(searchWithoutSpaces) ||
                    searchWords.every(word => normalizedDescription.includes(word));

                const tagMatches =
                    normalizedTag.includes(searchTerm) ||
                    normalizedTag.replace(/\s+/g, '').includes(searchWithoutSpaces);

                return nameMatches || descMatches || tagMatches;
            });

            // Include category if it matches or has matching subcategories
            if (categoryMatches || (filteredSubcategories && filteredSubcategories.length > 0)) {
                return {
                    ...category,
                    subcategories: categoryMatches ? category.subcategories : filteredSubcategories
                };
            }

            return null;
        }).filter(category => category !== null);

        setFilteredData(searchResults);
    };
    const applyFilter = (allData, vegOnly) => {
        let filtered = allData;

        // Apply veg filter if selected
        if (vegOnly !== null) {
            filtered = allData.map(category => {
                const filteredSubcategories = category.subcategories.filter(
                    sub => vegOnly ? sub.tag === "Veg" : sub.tag === "Non_Veg"
                );

                return {
                    ...category,
                    subcategories: filteredSubcategories
                };
            }).filter(cat => cat.subcategories.length > 0);
        }

        // Apply search if active
        if (searchActive && searchQuery) {
            filtered = filtered.map(category => {
                const categoryMatches = category.category?.toLowerCase().includes(searchQuery);

                const filteredSubcategories = category.subcategories.filter(sub =>
                    sub.subName?.toLowerCase().includes(searchQuery) ||
                    sub.description?.toLowerCase().includes(searchQuery)
                );

                if (categoryMatches || filteredSubcategories.length > 0) {
                    return {
                        ...category,
                        subcategories: categoryMatches ? category.subcategories : filteredSubcategories
                    };
                }
                return null;
            }).filter(category => category !== null);
        }

        setFilteredData(filtered);
    };


    const handleFileImport = async (e) => {
        const file = e.target.files[0];
        if (!file) return alert("Please choose a file.");

        const vendorId = localStorage.getItem("vendorId");
        const authToken = localStorage.getItem("authToken");

        if (!vendorId) return alert("Vendor ID not found in local storage.");
        if (!authToken) return alert("No auth token found. Please log in first.");

        const formData = new FormData();
        formData.append("file", file);

        try {
            const response = await axios.post(
                `https://backend.maamaas.com/food/api/dish/import/${vendorId}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            //console.log("✅ Import successful:", response.data);
            alert("✅ Categories imported successfully!");
            setTimeout(() => window.location.reload(), 1000);

        } catch (error) {
            console.error("❌ Import failed:", error);
            if (error.response) {
                alert(`❌ Import failed: ${error.response.status} - ${error.response.data?.message || "Server error"}`);
            } else {
                alert("❌ Import failed: Network or unknown error.");
            }
        }
    };
    // Fetch data on component mount
    const fetchData = async () => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId) {
            console.warn("⚠️ vendorId not found in localStorage");
            setError(new Error("vendorId missing"));
            setLoading(false);
            return;
        }

        if (!token) {
            console.warn("⚠️ authToken not found in localStorage");
            setError(new Error("authToken missing"));
            setLoading(false);
            return;
        }

        try {
            showLoader();
            const response = await fetch(
                `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`
                    }
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const dishData = await response.json();

            // Get parent categories (categories)
            const parentCategories = dishData.filter(item => item.parentId === 0 || item.parentId === null);

            // Format the data with categories and their subcategories
            let formattedData = parentCategories.map(category => {
                // Get subcategories for this category
                const subcategories = dishData.filter(sub => sub.parentId === category.dishId);

                return {
                    dishId: category.dishId,
                    SNo: category.dishId,
                    category: category.dishName,
                    quantity: category.stockQuantity || "-",
                    consumed: category.consumedQuantity || "-",
                    balance: category.balanceQuantity || "-",
                    itemStatus: category.menuStatus || "Enable",
                    isAdded: true,
                    subcategories: subcategories.map((sub, subIndex) => ({
                        dishId: sub.dishId,
                        subName: sub.subName || sub.dishName,
                        quantity: sub.stockQuantity || 0,
                        consumed: sub.consumedQuantity || 0,
                        balance: sub.balanceQuantity || 0,
                        itemStatus: sub.menuStatus || "Enable",
                        isSubcategory: true
                    }))
                };
            });

            //console.log("Formatted Item Update Data with subcategories:", formattedData);

            // Ensure category status reflects on subcategories (in case of data inconsistency)
            formattedData = formattedData.map(category => {
                // If category is disabled, disable all subcategories
                if (category.itemStatus === "Disable") {
                    return {
                        ...category,
                        subcategories: category.subcategories.map(sub => ({
                            ...sub,
                            itemStatus: "Disable"
                        }))
                    };
                }
                return category;
            });

            setData(formattedData);
            setFilteredData(formattedData);

        } catch (error) {
            console.error("Error fetching data:", error);
            setError(error);
        } finally {
            setLoading(false);
            hideLoader();
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    // Handle edit quantity
    const handleEditQuantity = (item, isSubcategory = false, parentIndex = null) => {
        setEditItem({
            ...item,
            newQuantity: item.quantity,
            isSubcategory,
            parentIndex
        });
        setShowEditModal(true);
    };

    // Submit edited quantity
    const submitEditQuantity = async () => {
        if (!editItem || !editItem.dishId) {
            alert("Dish ID is missing!");
            return;
        }

        const token = localStorage.getItem("authToken");
        if (!token) {
            alert("Authentication token missing. Please log in again.");
            return;
        }

        try {
            showLoader();
            const url = `https://backend.maamaas.com/food/api/dish/edit/${editItem.dishId}`;

            const formData = new FormData();

            // JSON data as blob - only update stockQuantity
            const dishData = {
                stockQuantity: editItem.newQuantity
                // Other fields will remain unchanged
            };

            formData.append("dishData", new Blob([JSON.stringify(dishData)], { type: "application/json" }));

            const response = await axios.put(url, formData, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            //console.log('Quantity update successful:', response.data);
            alert('Quantity updated successfully!');

            // Update local state
            if (editItem.isSubcategory && editItem.parentIndex !== null) {
                // Update subcategory quantity
                setData(prevData => {
                    const updatedData = [...prevData];
                    const subIndex = updatedData[editItem.parentIndex].subcategories.findIndex(
                        sub => sub.dishId === editItem.dishId
                    );
                    if (subIndex !== -1) {
                        updatedData[editItem.parentIndex].subcategories[subIndex].quantity = editItem.newQuantity;
                    }
                    return updatedData;
                });
                setFilteredData(prevData => {
                    const updatedData = [...prevData];
                    const subIndex = updatedData[editItem.parentIndex].subcategories.findIndex(
                        sub => sub.dishId === editItem.dishId
                    );
                    if (subIndex !== -1) {
                        updatedData[editItem.parentIndex].subcategories[subIndex].quantity = editItem.newQuantity;
                    }
                    return updatedData;
                });
            } else {
                // Update category quantity
                setData(prevData =>
                    prevData.map(item =>
                        item.dishId === editItem.dishId
                            ? { ...item, quantity: editItem.newQuantity }
                            : item
                    )
                );
                setFilteredData(prevData =>
                    prevData.map(item =>
                        item.dishId === editItem.dishId
                            ? { ...item, quantity: editItem.newQuantity }
                            : item
                    )
                );
            }

            setShowEditModal(false);
            setEditItem(null);

        } catch (error) {
            console.error("Error updating quantity:", error);
            if (error.response) {
                console.error("Response data:", error.response.data);
                alert(`Failed to update quantity: ${error.response.data.message || error.response.data}`);
            } else {
                alert(`Failed to update quantity: ${error.message}`);
            }
        } finally {
            hideLoader();
        }
    };

    // Handle toggle item status
    // Handle toggle item status
    const handleToggleStatus = async (index, dishId, currentStatus, isSubcategory = false, parentIndex = null) => {
        const vendorId = localStorage.getItem("vendorId");
        const authToken = localStorage.getItem("authToken");

        if (!vendorId || !authToken) {
            alert("Authentication failed. Please login again.");
            return;
        }
        // Prevent toggling subcategory if parent category is disabled
        if (isSubcategory && parentIndex !== null) {
            const parentCategory = data[parentIndex];
            if (parentCategory && parentCategory.itemStatus === "Disable") {
                alert("Cannot toggle subcategory when parent category is hidden.");
                return;
            }
        }

        const newBool = currentStatus !== "Enable";
        const newStatus = newBool ? "Enable" : "Disable";

        if (isSubcategory && parentIndex !== null) {
            // Update subcategory status
            setData(prevData => {
                const updatedData = [...prevData];
                const subIndex = updatedData[parentIndex].subcategories.findIndex(
                    sub => sub.dishId === dishId
                );
                if (subIndex !== -1) {
                    updatedData[parentIndex].subcategories[subIndex].itemStatus = newStatus;
                }
                return updatedData;
            });
            setFilteredData(prevData => {
                const updatedData = [...prevData];
                const subIndex = updatedData[parentIndex].subcategories.findIndex(
                    sub => sub.dishId === dishId
                );
                if (subIndex !== -1) {
                    updatedData[parentIndex].subcategories[subIndex].itemStatus = newStatus;
                }
                return updatedData;
            });
        } else {
            // Update category status - ALSO UPDATE ALL ITS SUBCATEGORIES
            setData(prevData => {
                const updatedData = [...prevData];
                updatedData[index] = {
                    ...updatedData[index],
                    itemStatus: newStatus,
                    // Also update all subcategories to same status
                    subcategories: updatedData[index].subcategories.map(sub => ({
                        ...sub,
                        itemStatus: newStatus
                    }))
                };
                return updatedData;
            });
            setFilteredData(prevData => {
                const updatedData = [...prevData];
                updatedData[index] = {
                    ...updatedData[index],
                    itemStatus: newStatus,
                    // Also update all subcategories to same status
                    subcategories: updatedData[index].subcategories.map(sub => ({
                        ...sub,
                        itemStatus: newStatus
                    }))
                };
                return updatedData;
            });
        }

        try {
            // For category, update all subcategories as well
            if (!isSubcategory) {
                // First update the category
                const categoryUrl = `https://backend.maamaas.com/food/api/dish/editmenu/${dishId}`;
                const categoryPayload = { menuStatus: newStatus };

                await axios.put(categoryUrl, categoryPayload, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${authToken}`,
                    },
                });

                // Then update all subcategories of this category
                const category = data[index];
                if (category.subcategories && category.subcategories.length > 0) {
                    for (const sub of category.subcategories) {
                        const subUrl = `https://backend.maamaas.com/food/api/dish/editmenu/${sub.dishId}`;
                        const subPayload = { menuStatus: newStatus };

                        await axios.put(subUrl, subPayload, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${authToken}`,
                            },
                        });

                        localStorage.setItem(`menuStatus-${sub.dishId}`, newStatus);
                    }
                }
            } else {
                // For subcategory, update only that subcategory
                const url = `https://backend.maamaas.com/food/api/dish/editmenu/${dishId}`;
                const payload = { menuStatus: newStatus };

                await axios.put(url, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${authToken}`,
                    },
                });
            }

            localStorage.setItem(`menuStatus-${dishId}`, newStatus);

        } catch (error) {
            console.error('Failed to toggle menu visibility:', error);
            alert('Failed to update menu visibility.');

            // Rollback UI
            if (isSubcategory && parentIndex !== null) {
                setData(prevData => {
                    const updatedData = [...prevData];
                    const subIndex = updatedData[parentIndex].subcategories.findIndex(
                        sub => sub.dishId === dishId
                    );
                    if (subIndex !== -1) {
                        updatedData[parentIndex].subcategories[subIndex].itemStatus = currentStatus;
                    }
                    return updatedData;
                });
                setFilteredData(prevData => {
                    const updatedData = [...prevData];
                    const subIndex = updatedData[parentIndex].subcategories.findIndex(
                        sub => sub.dishId === dishId
                    );
                    if (subIndex !== -1) {
                        updatedData[parentIndex].subcategories[subIndex].itemStatus = currentStatus;
                    }
                    return updatedData;
                });
            } else {
                setData(prevData => {
                    const updatedData = [...prevData];
                    updatedData[index].itemStatus = currentStatus;
                    // Also rollback subcategories
                    updatedData[index].subcategories = updatedData[index].subcategories.map(sub => ({
                        ...sub,
                        itemStatus: sub.itemStatus // Keep their original status or could store previous states
                    }));
                    return updatedData;
                });
                setFilteredData(prevData => {
                    const updatedData = [...prevData];
                    updatedData[index].itemStatus = currentStatus;
                    // Also rollback subcategories
                    updatedData[index].subcategories = updatedData[index].subcategories.map(sub => ({
                        ...sub,
                        itemStatus: sub.itemStatus
                    }));
                    return updatedData;
                });
            }
        }
    };
    const handleExport = () => {
        if (!filteredData || filteredData.length === 0) {
            alert("No data available to export.");
            return;
        }

        const exportData = [];

        filteredData.forEach((category, index) => {
            exportData.push({
                "S.No": index + 1,
                "Category": category.category || "",
                "Subcategory": "",
                "Quantity": category.quantity || "",
                "Consumed": category.consumed || "",
                "Balance": category.balance || "",
            });

            if (category.subcategories && category.subcategories.length > 0) {
                category.subcategories.forEach((sub) => {
                    exportData.push({
                        "S.No": "",
                        "Category": category.categoryName || "",
                        "Subcategory": sub.subName || "",
                        "Quantity": sub.quantity || "",
                        "Consumed": sub.consumed || "",
                        "Balance": sub.balance || "",
                    });
                });
            }
        });

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Menu Data");

        const colWidths = Object.keys(exportData[0]).map((key) => ({
            wch: Math.max(
                key.length,
                ...exportData.map((row) => String(row[key] || "").length)
            ),
        }));
        worksheet["!cols"] = colWidths;

        XLSX.writeFile(workbook, "menu_data_export.xlsx");
    };
    // Handle delete item
    const handleDeleteItem = async (dishId, isSubcategory = false, parentIndex = null) => {
        if (!window.confirm("Are you sure you want to delete this item?")) return;

        const token = localStorage.getItem("authToken");

        try {
            showLoader();
            const response = await fetch(
                `https://backend.maamaas.com/food/api/dish/delete/${dishId}`,
                {
                    method: "DELETE",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                    },
                }
            );

            if (response.ok) {
                alert("Item deleted successfully!");

                if (isSubcategory && parentIndex !== null) {
                    // Delete subcategory
                    setData(prevData => {
                        const updatedData = [...prevData];
                        updatedData[parentIndex].subcategories = updatedData[parentIndex].subcategories.filter(
                            sub => sub.dishId !== dishId
                        );
                        return updatedData;
                    });
                    setFilteredData(prevData => {
                        const updatedData = [...prevData];
                        updatedData[parentIndex].subcategories = updatedData[parentIndex].subcategories.filter(
                            sub => sub.dishId !== dishId
                        );
                        return updatedData;
                    });
                } else {
                    // Delete category
                    const newData = data.filter(item => item.dishId !== dishId);
                    setData(newData);
                    setFilteredData(newData);
                }
            } else {
                const result = await response.json();
                alert(`Failed to delete item. Error: ${result.message || "Unknown error"}`);
            }
        } catch (error) {
            alert("An error occurred while deleting.");
            console.error(error);
        } finally {
            hideLoader();
        }
    };

    // Get responsive units based on viewport
    const getResponsiveValue = (mobile, tablet, desktop) => {
        const width = window.innerWidth;
        if (width < 768) return mobile;
        if (width < 1024) return tablet;
        return desktop;
    };

    // Responsive container height using vh units
    const containerHeight = getResponsiveValue('48vh', '50vh', '50vh');

    // Responsive table styles using rem and % units
    const tableHeaderStyle = {
        border: '1px solid #ddd',
        textAlign: 'center',
        fontWeight: 'bold',
        backgroundColor: '#b15cd6',
        color: 'white',
        padding: getResponsiveValue('0.5rem', '0.75rem', '0.875rem'),
        fontSize: getResponsiveValue('0.75rem', '0.875rem', '1rem'),
        whiteSpace: 'nowrap',
    };

    const tableCellStyle = {
        border: '1px solid #ddd',
        textAlign: 'center',
        padding: getResponsiveValue('0.4rem', '0.6rem', '0.75rem'),
        fontSize: getResponsiveValue('0.75rem', '0.875rem', '1rem'),
        wordBreak: 'break-word',
    };

    const categoryRowStyle = {
        backgroundColor: '#f0f0f0',
        fontWeight: 'bold'
    };

    const subcategoryRowStyle = {
        backgroundColor: '#f9f9f9'
    };

    const editButtonStyle = {
        backgroundColor: '#fff',
        color: 'green',
        border: 'none',
        cursor: 'pointer',
        borderRadius: '0.25rem',
        marginRight: getResponsiveValue('0.25rem', '0.5rem', '0.625rem'),
        fontSize: getResponsiveValue('1rem', '1.125rem', '1.25rem'),
        padding: getResponsiveValue('0.25rem', '0.375rem', '0.5rem'),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
    };

    const deleteButtonStyle = {
        backgroundColor: '#fff',
        color: 'red',
        border: 'none',
        cursor: 'pointer',
        borderRadius: '0.25rem',
        fontSize: getResponsiveValue('1rem', '1.125rem', '1.25rem'),
        padding: getResponsiveValue('0.25rem', '0.375rem', '0.5rem'),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
    };

    const modalStyle = {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        padding: getResponsiveValue('1rem', '1.25rem', '1.5rem'),
        borderRadius: '0.625rem',
        boxShadow: '0 0.125rem 0.625rem rgba(0, 0, 0, 0.1)',
        zIndex: 1000,
        width: getResponsiveValue('85%', '75%', '50%'),
        maxWidth: '25rem',
    };

    const inputFieldStyle = {
        width: '100%',
        padding: getResponsiveValue('0.5rem', '0.625rem', '0.75rem'),
        fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem'),
        borderRadius: '0.375rem',
        border: '1px solid #ddd',
        marginBottom: '1rem',
        boxSizing: 'border-box',
    };

    const buttonContainerStyle = {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '1.25rem',
        textAlign: "center"
    };

    const buttonStyle = {
        height: getResponsiveValue('2rem', '2.25rem', '2.5rem'),
        backgroundColor: '#b15cd6',
        color: 'white',
        border: 'none',
        borderRadius: '0.375rem',
        cursor: 'pointer',
        fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem'),
        fontWeight: "bold",
        marginTop: "0.625rem",
        padding: getResponsiveValue('0 1rem', '0 1.25rem', '0 1.5rem'),
        minWidth: '8rem',
    };

    const closeButtonStyle = {
        position: 'absolute',
        top: getResponsiveValue('0.5rem', '0.75rem', '1rem'),
        right: getResponsiveValue('0.5rem', '0.75rem', '1rem'),
        cursor: 'pointer',
        fontSize: getResponsiveValue('1.25rem', '1.5rem', '1.75rem'),
        fontWeight: 'bold',
        color: '#888',
        lineHeight: '1',
        padding: '0.25rem',
    };

    return (
        <div style={{
            marginTop: window.innerWidth < 768 ? "0rem" : "-3.8rem",
            padding: getResponsiveValue('0.5rem', '1rem', '1rem'),
            width: window.innerWidth < 500 ? '98vw' : '100%',
            boxSizing: 'border-box',
            marginLeft: window.innerWidth < 500 ? '-8px' : "-1rem",
        }}>
            {/* <h2 style={{ 
                marginBottom: "1rem", 
                color: "#333",
                fontSize: getResponsiveValue('1.125rem', '1.5rem', '1.75rem'),
                textAlign: 'start',
                fontWeight: '600'
            }}>
                Items Update
            </h2> */}
            <div className="controls-container" style={{
                display: 'flex',
                flexDirection:window.innerWidth<420 ? "column" : window.innerWidth < 768 ? 'row-reverse' : 'row',
                justifyContent: window.innerWidth < 768 ? 'flex-start' : 'space-between',
                alignItems: window.innerWidth < 768 ? 'stretch' : 'center',
                marginBottom: window.innerWidth < 768 ? '10px' : '10px',
                gap: window.innerWidth < 768 ? '15px' : '10px',
                width: '100%',
                padding: window.innerWidth < 768 ? '0' : '0px',
                marginTop:window.innerWidth<769 ? "0.5rem" : "0.8rem",
                boxSizing: 'border-box',

            }}>

                {/* Buttons Group - Import/Export */}
                <div style={{
                    display: 'flex',
                    flexDirection: window.innerWidth < 480 ? 'row' : 'row',
                    gap: window.innerWidth < 480 ? '8px' : '10px',
                    justifyContent: window.innerWidth < 768 ? 'start' : 'flex-start',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    width: window.innerWidth < 768 ? '100%' : 'auto',
                    order: window.innerWidth < 768 ? 2 : 0 // Buttons come after search on mobile
                }}>
                    <input
                        type="file"
                        accept=".xlsx, .xls"
                        ref={fileInputRef}
                        onChange={handleFileImport}
                        style={{ display: 'none' }}
                    />

                    <button
                        style={{
                            backgroundColor: "#b15cd6",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            fontWeight: 'bold',
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                            height: window.innerWidth < 480 ? '32px' :
                                window.innerWidth < 768 ? '35px' : '38px',
                            padding: window.innerWidth < 480 ? '0 12px' :
                                window.innerWidth < 768 ? '0 15px' : '0 20px',
                            fontSize: window.innerWidth < 480 ? '0.75rem' :
                                window.innerWidth < 768 ? '0.85rem' : '0.9rem',
                            minWidth: window.innerWidth < 480 ? '90px' :
                                window.innerWidth < 768 ? '100px' : '110px',
                            transition: 'all 0.3s ease',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                            margin: 0
                        }}
                        onClick={() => fileInputRef.current.click()}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#9a4bc2'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = '#b15cd6'}
                    >
                        Import
                    </button>

                    <button
                        style={{
                            backgroundColor: "#b15cd6",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            fontWeight: 'bold',
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                            height: window.innerWidth < 480 ? '32px' :
                                window.innerWidth < 768 ? '35px' : '38px',
                            padding: window.innerWidth < 480 ? '0 12px' :
                                window.innerWidth < 768 ? '0 15px' : '0 20px',
                            fontSize: window.innerWidth < 480 ? '0.75rem' :
                                window.innerWidth < 768 ? '0.85rem' : '0.9rem',
                            minWidth: window.innerWidth < 480 ? '90px' :
                                window.innerWidth < 768 ? '100px' : '110px',
                            transition: 'all 0.3s ease',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                            margin: 0
                        }}
                        onClick={handleExport}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#9a4bc2'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = '#b15cd6'}
                    >
                        Export
                    </button>
                </div>

                {/* Search Bar - Always on top for mobile, on right for desktop */}
                <div style={{
                    position: 'relative',
                    width: '100%',
                    maxWidth: window.innerWidth < 768 ? '200' : '250px',
                    minWidth: window.innerWidth < 480 ? '150px' : '200px',
                    margin: 0,
                    order: window.innerWidth < 768 ? 1 : 0, // Search comes first on mobile
                    zIndex: 1
                }}>
                    <input
                        type="text"
                        placeholder="Search dishes or categories..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') handleSearch(searchQuery);
                        }}
                        onKeyUp={(e) => {
                            if (e.key !== 'Enter' && e.key !== 'Tab') {
                                handleSearch(searchQuery);
                            }
                        }}
                        style={{
                            width: '100%',
                            padding: window.innerWidth < 480 ? '8px 40px 8px 12px' :
                                window.innerWidth < 768 ? '10px 42px 10px 14px' : '10px 42px 10px 16px',
                            borderRadius: '20px',
                            border: '2px solid #b15cd6',
                            fontSize: window.innerWidth < 480 ? '0.875rem' :
                                window.innerWidth < 768 ? '0.9rem' : '1rem',
                            outline: 'none',
                            transition: 'all 0.3s ease',
                            backgroundColor: '#fff',
                            height: window.innerWidth < 480 ? '36px' :
                                window.innerWidth < 768 ? '38px' : '40px',
                            boxSizing: 'border-box',
                            fontFamily: 'inherit',
                        }}
                        onFocus={(e) => {
                            e.target.style.boxShadow = '0 0 0 2px rgba(177, 92, 214, 0.2)';
                        }}
                        onBlur={(e) => {
                            e.target.style.boxShadow = 'none';
                        }}
                    />
                    <button
                        onClick={() => handleSearch(searchQuery)}
                        style={{
                            position: 'absolute',
                            right: window.innerWidth < 480 ? '10px' :
                                window.innerWidth < 768 ? '5px' : '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                            padding: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 2
                        }}
                        type="button"
                        aria-label="Search"
                    >
                        <svg
                            width={window.innerWidth < 480 ? "18" :
                                window.innerWidth < 768 ? "20" : "22"}
                            height={window.innerWidth < 480 ? "18" :
                                window.innerWidth < 768 ? "20" : "22"}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#b15cd6"
                            strokeWidth="2"
                        >
                            <circle cx="11" cy="11" r="8" />
                            <path d="m21 21-4.3-4.3" />
                        </svg>
                    </button>

                    {/* Clear button for search */}
                    {searchQuery && (
                        <button
                            onClick={() => {
                                setSearchQuery("");
                                handleSearch("");
                            }}
                            style={{
                                position: 'absolute',
                                right: window.innerWidth < 480 ? '35px' :
                                    window.innerWidth < 768 ? '40px' : '45px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: 'transparent',
                                border: 'none',
                                cursor: 'pointer',
                                padding: '2px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#888',
                                fontSize: window.innerWidth < 480 ? '18px' : '20px',
                                fontWeight: 'bold',
                                zIndex: 2
                            }}
                            type="button"
                            aria-label="Clear search"
                        >
                            ×
                        </button>
                    )}
                </div>
            </div>

            <div style={{
                overflowX: "auto",
                overflowY: "auto",
                height: containerHeight,
                border: '0px solid #ddd',
                borderRadius: '0.375rem',
                backgroundColor: '#fff',
                width: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
                scrollbarWidth: "thin",
            }}
                className="item-updates-table-data" >

                {loading ? (
                    <div style={{
                        textAlign: 'center',
                        padding: '1.25rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%'
                    }}>
                        <p style={{ fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem') }}>
                            Loading data...
                        </p>
                    </div>
                ) : error ? (
                    <div style={{
                        textAlign: 'center',
                        padding: '1.25rem',
                        color: 'red',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%'
                    }}>
                        <p style={{ fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem') }}>
                            Error fetching data: {error.message}
                        </p>
                    </div>
                ) : filteredData.length === 0 ? (
                    <div style={{
                        textAlign: 'center',
                        padding: '1.25rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%'
                    }}>
                        <p style={{ fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem') }}>
                            No items found
                        </p>
                    </div>
                ) : (
                    <table style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        tableLayout: 'auto',
                        marginTop: "0",
                        minWidth: getResponsiveValue('100%', '100%', '100%'),
                    }}>
                        <thead>
                            <tr>
                                <th style={{ ...tableHeaderStyle, width: '8%' }}>SNo</th>
                                <th style={{ ...tableHeaderStyle, width: '25%' }}>category</th>
                                <th style={{ ...tableHeaderStyle, width: '12%' }}>Quantity</th>
                                <th style={{ ...tableHeaderStyle, width: '12%' }}>Consumed</th>
                                <th style={{ ...tableHeaderStyle, width: '12%' }}>Balance</th>
                                <th style={{ ...tableHeaderStyle, width: '15%' }}>Status</th>
                                <th style={{ ...tableHeaderStyle, width: '16%' }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map((item, index) => (
                                <React.Fragment key={item.dishId}>
                                    {/* Parent Category Row */}
                                    <tr style={categoryRowStyle}>
                                        <td style={tableCellStyle}>{index + 1}</td>
                                        <td style={tableCellStyle}>
                                            <strong style={{ fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem') }}>
                                                {item.category}
                                            </strong>
                                        </td>
                                        <td style={tableCellStyle}>{item.quantity}</td>
                                        <td style={tableCellStyle}>{item.consumed}</td>
                                        <td style={tableCellStyle}>{item.balance}</td>
                                        <td style={tableCellStyle}>
                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                height: '100%'
                                            }}>
                                                <label className="switch">
                                                    <input
                                                        type="checkbox"
                                                        checked={item.itemStatus === "Disable"}
                                                        onChange={() => handleToggleStatus(index, item.dishId, item.itemStatus, false)}
                                                    />
                                                    <span className="slider round"></span>
                                                </label>
                                                <span
                                                    style={{
                                                        marginTop: '0.25rem',
                                                        color: 'black',
                                                        fontSize: getResponsiveValue('0.75rem', '0.875rem', '1rem'),
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    {item.itemStatus === "Disable" ? 'Hide' : 'Show'}
                                                </span>
                                            </div>
                                        </td>
                                        <td style={tableCellStyle}>
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                gap: getResponsiveValue('0.25rem', '0.5rem', '0.75rem')
                                            }}>
                                                <button
                                                    style={editButtonStyle}
                                                    onClick={() => handleEditQuantity(item, false)}
                                                    title="Edit Quantity"
                                                    aria-label="Edit Quantity"
                                                >
                                                    <FaEdit />
                                                </button>
                                                {/* <button
                                                    style={deleteButtonStyle}
                                                    onClick={() => handleDeleteItem(item.dishId, false)}
                                                    title="Delete"
                                                    aria-label="Delete"
                                                >
                                                    <FaTrash />
                                                </button> */}
                                            </div>
                                        </td>
                                    </tr>

                                    {/* Subcategories */}
                                    {item.subcategories && item.subcategories.map((sub, subIndex) => (
                                        <tr key={`sub-${sub.dishId}`} style={subcategoryRowStyle}>
                                            <td style={tableCellStyle}>
                                                {index + 1}.{subIndex + 1}
                                            </td>
                                            <td style={tableCellStyle}>
                                                <span style={{
                                                    marginLeft: getResponsiveValue('1rem', '1.5rem', '2rem'),
                                                    display: 'block',
                                                    textAlign: 'left',
                                                    fontSize: getResponsiveValue('0.75rem', '0.875rem', '1rem')
                                                }}>
                                                    ↳ {sub.subName}
                                                </span>
                                            </td>
                                            <td style={tableCellStyle}>{sub.quantity}</td>
                                            <td style={tableCellStyle}>{sub.consumed}</td>
                                            <td style={tableCellStyle}>{sub.balance}</td>
                                            <td style={tableCellStyle}>
                                                <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    height: '100%'
                                                }}>
                                                    <label className="switch">
                                                        <input
                                                            type="checkbox"
                                                            checked={sub.itemStatus === "Disable"}
                                                            onChange={() => handleToggleStatus(subIndex, sub.dishId, sub.itemStatus, true, index)}
                                                            disabled={item.itemStatus === "Disable"} // 👈 DISABLE WHEN PARENT IS HIDDEN
                                                        />
                                                        <span className={`slider round ${item.itemStatus === "Disable" ? 'disabled' : ''}`}></span>
                                                    </label>
                                                    <span
                                                        style={{
                                                            marginTop: '0.25rem',
                                                            color: item.itemStatus === "Disable" ? '#999' : 'black', // Gray out text
                                                            fontSize: getResponsiveValue('0.75rem', '0.875rem', '1rem'),
                                                            cursor: item.itemStatus === "Disable" ? 'not-allowed' : 'pointer',
                                                        }}
                                                    >
                                                        {sub.itemStatus === "Disable" ? 'Hide' : 'Show'}
                                                    </span>
                                                </div>
                                            </td>
                                            <td style={tableCellStyle}>
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    gap: getResponsiveValue('0.25rem', '0.5rem', '0.75rem')
                                                }}>
                                                    <button
                                                        style={{
                                                            ...editButtonStyle,
                                                            opacity: item.itemStatus === "Disable" ? 0.5 : 1, // 👈 Gray out when disabled
                                                            cursor: item.itemStatus === "Disable" ? 'not-allowed' : 'pointer'
                                                        }}
                                                        onClick={() => item.itemStatus !== "Disable" && handleEditQuantity(sub, true, index)} // 👈 Only clickable when parent not disabled
                                                        title="Edit Quantity"
                                                        aria-label="Edit Quantity"
                                                        disabled={item.itemStatus === "Disable"} // 👈 Disable button
                                                    >
                                                        <FaEdit />
                                                    </button>
                                                    {/* <button
                                                        style={{
                                                            ...deleteButtonStyle,
                                                            opacity: item.itemStatus === "Disable" ? 0.5 : 1,
                                                            cursor: item.itemStatus === "Disable" ? 'not-allowed' : 'pointer'
                                                        }}
                                                        onClick={() => item.itemStatus !== "Disable" && handleDeleteItem(sub.dishId, true, index)}
                                                        title="Delete"
                                                        aria-label="Delete"
                                                        disabled={item.itemStatus === "Disable"}
                                                    >
                                                        <FaTrash />
                                                    </button> */}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

            {/* Edit Quantity Modal */}
            {/* Edit Quantity Modal - Horizontal layout */}
            {showEditModal && editItem && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000,
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        padding: '1.5rem',
                        borderRadius: '8px',
                        width: '380px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        position: 'relative',
                    }}>
                        {/* Close button - top right */}
                        <button
                            onClick={() => setShowEditModal(false)}
                            style={{
                                position: 'absolute',
                                top: '0px',
                                right: '0px',
                                background: 'none',
                                border: 'none',
                                fontSize: '1.5rem',
                                cursor: 'pointer',
                                color: '#999',
                                padding: '0',
                                lineHeight: '1',
                                width: '24px',
                                height: '24px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                transition: 'all 0.2s',
                            }}
                            onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                        >
                            ×
                        </button>

                        {/* Horizontal layout */}
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '1rem',
                        }}>
                            {/* Item name */}
                            <div style={{
                                flex: '1',
                                fontSize: '0.95rem',
                                fontWeight: '600',
                                color: '#333',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                minWidth: '80px',
                            }}>
                                {editItem.isSubcategory ? editItem.subName : editItem.category}
                            </div>

                            {/* Quantity input */}
                            <div style={{ flex: '1' }}>
                                <input
                                    type="number"
                                    value={editItem.newQuantity}
                                    onChange={(e) => setEditItem({ ...editItem, newQuantity: e.target.value })}
                                    style={{
                                        width: '90%',
                                        padding: '0.65rem 0.75rem',
                                        border: '1px solid #ddd',
                                        borderRadius: '6px',
                                        fontSize: '0.9rem',
                                        boxSizing: 'border-box',
                                        transition: 'border 0.2s',
                                    }}
                                    min="0"
                                    placeholder="Qty"
                                    autoFocus
                                    onFocus={(e) => e.target.style.borderColor = '#b15cd6'}
                                    onBlur={(e) => e.target.style.borderColor = '#ddd'}
                                />
                            </div>

                            {/* Save button */}
                            <button
                                onClick={submitEditQuantity}
                                style={{
                                    backgroundColor: '#b15cd6',
                                    color: 'white',
                                    border: 'none',
                                    padding: '0.65rem 1.25rem',
                                    borderRadius: '6px',
                                    fontSize: '0.9rem',
                                    cursor: 'pointer',
                                    fontWeight: '600',
                                    whiteSpace: 'nowrap',
                                    transition: 'all 0.2s',
                                    minWidth: '80px',
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#9a4bc1'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = '#b15cd6'}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <style>
                {`
                .switch .slider.disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.switch .slider.disabled::before {
    background-color: #888;
}
                `}
            </style>
        </div>
    );
};

const importExportButton = {
    height: '35px',
    marginTop: "20px",
    borderRadius: "4px",
    border: "none",
    backgroundColor: "#b15cd6",
    color: "white",
    fontWeight: 'bold',
    fontSize: "0.75rem",
};

export default ItemUpdates;